<template>
  <div class="avecor-table" >
    <v-tabs
      fixed-tabs
      dark
      height="30"
      dense
      v-model="selectedWarehouseTab"
      class="promotion-tabs"
      background-color="#F26539"
      style="position:fixed;top:35px;z-index:20;border-bottom:1px solid orange;" 
    >
      <v-tabs-slider color="#FFF" ></v-tabs-slider>
      <v-tab href="#warehouse">Varasto</v-tab>
      <v-tab href="#campaignProducts">Kampanjatuotteet</v-tab>
    </v-tabs>
    <v-toolbar class="avecor-table-toolbar" flat style="margin-top:26px;z-index:100;">
      <v-toolbar-title >Varasto</v-toolbar-title>
      <v-col cols="4" pl-4 class="text-center">
        <v-row no-gutters>
          <v-col cols="2" class="pt-2">
            <div style="font-size:14px">{{amountOfStockProducts}}</div>
            <div style="font-size:8px">Tuotetta</div>
          </v-col>
          <!-- <v-col cols="2" class="pt-2">
            <div style="font-size:14px">{{totalStockInWarehouse}}</div>
            <div style="font-size:8px">Varastossa</div>
          </v-col> -->
          <v-col cols="4" class="pt-2 pl-3 text-left">
            <div v-if="allAccess">
              <!-- <div style="font-size:10px"><span style="width:60px;display:inline-block">Avecor:</span> {{totalStockInAvecorWarehouse + " / " + totalStockValueInAvecorWarehouse.toFixed(2) + "€"}}</div>
              <div style="font-size:10px"><span style="width:60px;display:inline-block">Merkkaamot:</span> {{totalStockInPrintShopWarehouse + " / " + totalStockValueInPrintShopWarehouse.toFixed(2) + "€"}}</div> -->
              <div style="font-size:11px"><span style="width:65px;display:inline-block;font-weight:600;">Määrä:</span> {{totalStockInAvecorWarehouseNEW}}</div>
              <div style="font-size:11px"><span style="width:65px;display:inline-block;font-weight:600;">Arvo:</span> {{totalStockValueInAvecorWarehouseNEW + "€"}}</div>
              <!-- <div style="font-size:10px"><span style="width:60px;display:inline-block">Merkkaamot:</span> {{totalStockInPrintShopWarehouseNEW + " / " + totalStockValueInPrintShopWarehouseNEW.toFixed(2) + "€"}}</div> -->
            </div>
          </v-col>
          <v-col cols="3" class="pt-2 pl-3 text-left">
            <div style="font-size:10px" v-if="allAccess">
              <div :style="'color:'+settings.batchArrivalDateStatusColors['exceeded']">{{numberOfExceededArrivalDates}} erän saapmisaika ylittynyt</div>
              <div :style="'color:'+settings.batchArrivalDateStatusColors['within3days']">{{numberOfWithin3DaysArrivalDates}} erän saapumispäivä &#60;3 pv.</div>
            </div>
          </v-col>
          <v-col cols="3" class="text-left">
            <v-checkbox 
              v-if="!isSales && selectedWarehouseTab === 'warehouse'"
              style="margin-top:0px;"
              label="Näytä erätiedot?"
              v-model="showBatchInformation" 
              class="avecor-table-checkbox mt-1">
            </v-checkbox>
            <v-checkbox 
              v-if="!isSales && selectedWarehouseTab === 'warehouse'"
              style="margin-top:0px;"
              label="Halytysrajan alittaneet"
              v-model="showOnlyUnderAvecorStockNotifyLevel" 
              class="avecor-table-checkbox mt-1">
            </v-checkbox>
            <!-- <v-checkbox 
              style="margin-top:0px;"
              label="Näytä hyllytetyt erät?"
              v-model="showShelfedBatches" 
              class="avecor-table-checkbox mt-1">
            </v-checkbox> -->
          </v-col>
        </v-row>
      </v-col>
      
      
      <v-col >
        <v-text-field
          :value="productsSearch"
          @change="(event) => productsSearch = event"
          class="table-search avecor-select"
          label="Etsi tuotteita tästä"
          single-line
          hide-details
          autocomplete="off"
        ></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <!-- <v-col cols="1" v-if="allAccess">
        <v-switch
            v-model="showAllBatches"
            label="Näytä loppuneet erät?"
            color="orange darken-3"
            hide-details
          ></v-switch>
      </v-col> -->
      <!-- <v-col cols="3" pl-4 class="text-right">
        <v-btn-toggle v-if="!settings.isSales" :multiple="false" :mandatory="true" style="border:1px #ccc solid; " v-model="warehouseFilter">
          <v-btn height="30" class="avecor-button-global avecor-button-group-button" value="all">
            Kaikki
          </v-btn>
          <v-btn height="30" class="avecor-button-global avecor-button-group-button" value="exceededArrivalDate">
            Erän saapimusaika ylittynyt
          </v-btn>
          <v-btn height="30" class="avecor-button-global avecor-button-group-button" value="within3daysArrivalDate">
            Saapuvat erät &#60;3 pv.
          </v-btn>
        </v-btn-toggle>
      </v-col> -->
      
      <!-- <v-autocomplete
        v-if="allAccess"
        v-model="selectedWarehouse"
        autocomplete="off"
        :items="getWarehousedCustomers"
        label="Valitse varasto"
        placeholder="  "
        outlined
        dense
        persistent-hint
        item-text="text"
        item-value="value"
        class="avecor-select hide-field-details mr-5 mt-1"
        style="max-width:200px;z-index:1000"
      /> -->
      <!-- <v-btn v-if="device === 'desktop' && allAccess" @click.stop="isWarehouseProductSelectionOpen = false; isWarehouseCustomersSelectionOpen = !isWarehouseCustomersSelectionOpen" color="#000000" dark class="avecor-button-global add-button mb-2 mr-5 mt-3" :style="isWarehouseCustomersSelectionOpen ? 'background:#ccc !important' : ''">{{ isWarehouseCustomersSelectionOpen ? 'Sulje varastoasiakkaiden muokkaus' : 'Muokkaa varastoasiakkaita' }}</v-btn> -->
      <v-btn v-if="device === 'desktop' && allAccess" @click.stop="isWarehouseCustomersSelectionOpen = false; isWarehouseProductSelectionOpen = !isWarehouseProductSelectionOpen" color="#000000" dark class="avecor-button-global add-button mb-2 mr-5 mt-3" :style="isWarehouseProductSelectionOpen ? 'background:#ccc !important' : ''">{{ isWarehouseProductSelectionOpen ? 'Sulje varastotuotteiden muokkaus' : 'Muokkaa varastotuotteita'}}</v-btn>
      <v-btn v-if="device === 'desktop' && allAccess" @click.stop="exportStockTable()" color="#000000" dark class="avecor-button-global add-button mb-2 mr-5 mt-3" >Export</v-btn>
      <v-btn v-if="device === 'desktop' && user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'" @click.stop="saveReserved()" color="#000000" dark class="avecor-button-global add-button mb-2 mr-5 mt-3" >Tal varaukset</v-btn>
      
    </v-toolbar>
    <ProductExpand v-if="selectedProductId ? true: false" 
      :productId="selectedProductId" 
      :productVariationsForSelectedProduct="productsData[selectedProductId] !== undefined && productsData[selectedProductId].productVariations !== undefined ? productsData[selectedProductId].productVariations : {}" 
      :orderedProductsForSelectedProduct="null"
      location="stock" 
      tab="batches"
    />
    <WholesaleCompanyExpand v-if="selectedWholesaleCompanyId ? true: false" location="stock" />
    <OrderExpand  location="stock" v-if="selectedOrderOrderId ? true: false" />
    <!-- MANAGE WAREHOUSE PRODUCTS -->
    <v-navigation-drawer
      :style="'margin-top:149px;z-index:1003'"
      color="#FAFAFA"
      :mini-variant="true"
      mini-variant-width="600"
      fixed
      light
      right
      v-model="isWarehouseProductSelectionOpen"
      id="contact-drawer"
    >
      <v-row no-gutters class="pb-4 " style="margin-left:1px;position:absolute;background:#FFF;width:100%;z-index:100;border-bottom:1px solid #ccc">
        <v-col cols="12" >
            <div style="font-weight:600" class="pl-4 pt-4 ">{{selectedWarehouse === 'avecor' ? 'Avecor' : companies[selectedWarehouse].companyName}} varaston tuotteet</div>
        </v-col>
        <v-col cols="12" >
          <v-text-field
            :value="productsSearchInDrawer"
            @change="(event) => productsSearchInDrawer = event"
            class="table-search avecor-select pl-4"
            label="Etsi tuotteita tästä"
            single-line
            hide-details
            autocomplete="off"
          ></v-text-field>
        </v-col>
      </v-row>
      <div style="margin-top:120px;padding-bottom:250px">
        <v-lazy
          style="width:100%; padding:0px; margin:0px;min-height:50px;"
          :options="{threshold: .1}"
          v-for="p in getAllProducts" 
          :key="'warehouse-p-'+p.id"
        >
          <div>
          <!-- <div no-gutters v-for="p in getAllProducts" :key="p.id" style=""> -->
            <v-row  no-gutters>
              <v-col :cols="12" class="pl-6 pt-2" ><!-- NIMI -->
                <div class="stock-bolded-field">{{p.name}}</div>
              </v-col>
            </v-row>
            <div v-for="(pvId) in Object.keys(p.productVariations)" :key="'drawer-pv-'+pvId" style="width:100%;" >
              <v-row  class="" no-gutters  style="width:100%;" >
                <v-col class="orders-custom-header" cols="1"></v-col>
                <v-col class="orders-custom-header pl-3 pt-3" cols="1" style="z-index:1 !important">
                  <div v-if="selectedWarehouse === 'avecor'">
                    <v-icon v-if="p.productVariations[pvId].warehoused" style="cursor:pointer;z-index:1 !important" size="18" @mouseup.stop="saveWarehousedStatus(selectedWarehouse,pvId,false)" color="green">fas fa-check-square</v-icon>
                    <v-icon v-else @mouseup.stop="saveWarehousedStatus(selectedWarehouse,pvId,true)" style="cursor:pointer" size="18" color="grey">far fa-square</v-icon>
                  </div>
                  <div v-else>
                    <v-icon v-if="p.productVariations[pvId].customersWarehoused[selectedWarehouse] && p.productVariations[pvId].customersWarehoused[selectedWarehouse].warehoused" style="cursor:pointer;z-index:1 !important" size="18" @mouseup.stop="saveWarehousedStatus(selectedWarehouse,pvId,false)" color="green">fas fa-check-square</v-icon>
                    <v-icon v-else @mouseup.stop="saveWarehousedStatus(selectedWarehouse,pvId,true)" style="cursor:pointer" size="18" color="grey">far fa-square</v-icon>
                  </div>
                </v-col>
                <v-col :cols="10" class="pl-2" > <!-- NIMI -->
                  <div class="stock-custom-field">
                    
                    <div class=""><b>Variaatio: </b>{{p.productVariations[pvId].name}}</div>
                    <div style="cursor:pointer;" v-if="p.productVariations[pvId].avecorSku !== ''" @click="copyToClipboard(p.productVariations[pvId].avecorSku)"><b>Tuotekoodi: </b>{{p.productVariations[pvId].avecorSku}}</div>
                  </div>
                </v-col>
                
              </v-row>
            </div>
          </div>
        </v-lazy>
        <v-row no-gutters style="margin-top:50px;margin-bottom:50px;">
          <v-col cols="12" class="text-center">
            <v-btn v-if="isThereMoreProductsToShow" color="orange" style="color:#fff" @click="productsToShow = productsToShow + productsToShowIncrement">Näytä lisää tuotteita</v-btn>
          </v-col>
        </v-row>
      </div>
    </v-navigation-drawer>


    <!-- MANAGE WAREHOUSE CUSTOMERS -->
    <v-navigation-drawer
      :style="'margin-top:149px;z-index:1003'"
      color="#FAFAFA"
      :mini-variant="true"
      mini-variant-width="600"
      fixed
      light
      right
      v-model="isWarehouseCustomersSelectionOpen"
      id="contact-drawer"
    >
      <v-row no-gutters class="pb-4 " style="margin-left:1px;position:absolute;background:#FFF;width:100%;z-index:100;border-bottom:1px solid #ccc">
        <v-col cols="12" >
            <div style="font-weight:600" class="pl-4 pt-4 ">Muokkaa varastoasiakkaita</div>
        </v-col>
        <v-col cols="12" >
          <v-text-field
            :value="companiesSearchInDrawer"
            @change="(event) => companiesSearchInDrawer = event"
            class="table-search avecor-select pl-4"
            label="Etsi asiakkaita tästä"
            single-line
            hide-details
            autocomplete="off"
          ></v-text-field>
        </v-col>
      </v-row>
      <div style="margin-top:120px;padding-bottom:250px">
        <div no-gutters v-for="c in getAllCompanies" :key="c.id" style="">
          <v-row  no-gutters>
            <v-col :cols="12" class="pl-3 pt-2" ><!-- NIMI -->
              <div class="">
                <v-icon v-if="c.customerProductsWarehoused" style="cursor:pointer;z-index:1 !important" size="18" @mouseup.stop="saveCompanyDetails(c.id,'customerProductsWarehoused',false)" color="green">fas fa-check-square</v-icon>
                <v-icon v-else @mouseup.stop="saveCompanyDetails(c.id,'customerProductsWarehoused',true)" style="cursor:pointer" size="18" color="grey">far fa-square</v-icon>
                <span class="stock-bolded-field pl-3">{{c.name}}</span>
                <span class="pl-2" style="font-weight:300;font-size:10px" v-if="c.companyId">Y-tunnus: {{ c.companyId}}</span>
                <span class="pl-2" style="font-weight:300;font-size:10px;" v-if="c.netvisorId">Netvisor id:{{ c.netvisorId}}</span>
                <span class="pl-2" style="font-weight:300" >
                  <v-text-field
                    :value="companies[c.id].shopifyCustomerIdTag"
                    style="display:inline-block;width:200px"
                    class="avecor-select my-0 py-0"
                    label="SHOPIFY TAGIN TUNNUS"
                    filled
                    dense
                    single-line
                    hide-details
                    autocomplete="off"
                    @change="(event) => saveCompanyUpdate(c.id,'shopifyCustomerIdTag',event) "
                  ></v-text-field></span>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-row no-gutters style="margin-top:50px;margin-bottom:50px;">
          <v-col cols="12" class="text-center">
            <v-btn v-if="isThereMoreCompaniesToShow" color="orange" style="color:#fff" @click="companiesToShow = companiesToShow + companiesToShowIncrement">Näytä lisää yrityksiä</v-btn>
          </v-col>
        </v-row>
      </div>
    </v-navigation-drawer>


    <v-container class="stock-table-headers-sticky" fluid style=" width:100%;">
      <v-row no-gutters style="">
        <v-col cols="7">
          <v-row no-gutters class="ml-10 mr-2">
            <!-- <v-col cols="1" class="orders-custom-header pl-0" style="max-width:30px;" ></v-col> -->
            <v-col :cols="allAccess ? 3 : 3" class="pl-2 orders-custom-header">Tuotenimi</v-col>
                  <!-- <v-col cols="4" v-if="staff[user.uid] !== undefined && (staff[user.uid].isAdmin || staff[user.uid].role == 'office' || staff[user.uid].role == 'warehouse')" class="orders-custom-header">Toimiston kommentti</v-col> -->
            <!-- 
            <v-col cols="1" v-if="allAccess" class="orders-custom-header pl-0">Erän määrä</v-col>
            <v-col cols="1" class="orders-custom-header pl-0">Myytävissä</v-col>
            <v-col cols="1" class="orders-custom-header pl-0">Eräpäivä</v-col> 
            -->
            
            <v-col cols="4">
              <v-row no-gutters>
                <v-col cols="4" v-if="newVersion" class="orders-custom-header pl-0"><div>Saatavilla</div></v-col>
                <v-col cols="4" v-if="newVersion" class="orders-custom-header pl-0"><div>Varauksessa</div></v-col>
                <v-col cols="4" v-if="newVersion" class="orders-custom-header pl-0"><div>Avecor <!-- </div><div> -->varasto</div></v-col>
                <!-- <v-col cols="3" v-if="newVersion" class="orders-custom-header pl-0"><div>Merkkaamo varasto</div></v-col> -->
                

                <v-col cols="4" v-if="!newVersion" class="orders-custom-header pl-0"><div>Avecor <!-- </div><div> -->saldo</div></v-col>
                <v-col cols="4" v-if="!newVersion" class="orders-custom-header pl-0"><div>Merkkaamo saldo</div></v-col>
                <v-col cols="2" v-if="!newVersion" class="orders-custom-header pl-0"><div>Keskeneräiset</div></v-col>
                <v-col cols="2" v-if="!newVersion" class="orders-custom-header pl-0"><div>Varauksessa</div></v-col>
              </v-row>
            </v-col>
            <v-col :cols="allAccess ? 1 : 2"  class="orders-custom-header pl-0"><div>Sisäänostohinta </div></v-col>
            <v-col cols="1"  v-if="allAccess" class="orders-custom-header pl-0"><div>Ostohinta (o)</div></v-col>
            <!-- <v-col cols="2" class="orders-custom-header pl-0">Minimitilaus</v-col>
            <v-col cols="2" class="orders-custom-header pl-0">Pientilauslisä</v-col> -->
            
            <!-- <v-col v-if="allAccess" cols="1" class="orders-custom-header pl-0">Rahdin hinta (o)</v-col> -->
            <!-- <v-col v-if="allAccess" cols="1" class="orders-custom-header pl-0">Tullaus (o)</v-col> -->
            <v-col cols="3" class="orders-custom-header pl-0">Kommentit myyjille</v-col>
          </v-row>
        </v-col>
        <v-col cols="5" class="pl-3">
          <v-row no-gutters>
            <!-- <v-col :cols="allAccess ? 3 : 8" class="orders-custom-header pl-0">Tuote lisätiedot</v-col> -->
            <v-col v-if="allAccess" cols="4" class="orders-custom-header pl-0">Varasto lisätiedot (o)</v-col>
            <!-- <v-col cols="1" class="orders-custom-header">Parasta ennen</v-col> -->
            <v-col cols="2" class="orders-custom-header pl-0">Toimitusaika</v-col>
            <v-col cols="2" class="orders-custom-header pl-0">Merkkaustuote</v-col>
            <v-col v-if="allAccess" cols="2" class="orders-custom-header pl-0">Tukkuri (office)</v-col>
            <v-col v-if="allAccess" cols="2" class="orders-custom-header pl-0">Merkkaamo (office)</v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid ma-0 px-0 pt-0 style="position:absolute; top:135px; padding-bottom:500px; width:100%; border-top:1px solid #ccc;" ><!-- :key="batchesKey" -->
      <v-lazy
        style="width:100%; padding:0px; margin:0px;min-height:50px; border-bottom:1px solid #ccc;"
        :options="{
          threshold: .1
        }"
        v-for="(p) in getWarehouseProducts"
        :key="'product-'+p.id"
      >
        <v-row class="" no-gutters  style="width:100%; ">
          <v-col class="py-1" cols="7" style="background:#F8F8F8;border-right:1px solid #ccc">
            <v-row  no-gutters>
              <v-col class="orders-custom-header " style="max-width:35px;" cols="1">
                <div class="justify-center text-center pl-1" >
                  <!-- {{productsData[p.id].productVariations}} -->
                  <v-icon v-if="allAccess" :size="9" @click="selectedProductId = p.id;selectedWholesaleCompanyId = null;selectedOrderOrderId=null;" style="padding-right:3px;">far fa-eye</v-icon>
                  <v-icon v-if="allAccess" :size="9" color="green" @mouseup.stop="saveWarehouseStatusForProduct(selectedWarehouse,p.id,false);" style="padding-right:1px;cursor:pointer">fas fa-warehouse</v-icon>

                  
                </div>
              </v-col>
              <v-col :cols="allAccess ? 9 : 9" class="pl-2" ><!-- NIMI -->
                <div class="stock-bolded-field" style="font-size:12px">{{p.name}}
                  <span v-if="selectedWarehouse === 'avecor'">
                    <!-- <v-btn x-small @mouseup.stop="saveWarehouseStatusForProduct(selectedWarehouse,p.id,false);" class="add-button avecor-button-global ml-4" style="height:15px !important;font-size:8px !important;">Poista tuote varastosta</v-btn> -->
                    <!-- <b>Varastotuote:</b> 
                    <v-icon v-if="p.warehoused" style="cursor:pointer;z-index:1 !important" size="12" @mouseup.stop="saveWarehouseStatusForProduct(selectedWarehouse,p.id,false);" color="green">fas fa-check-square</v-icon>
                    <v-icon v-else @mouseup.stop="saveWarehouseStatusForProduct(selectedWarehouse,pv.id,true)" style="cursor:pointer" size="12" color="grey">far fa-square</v-icon> -->
                  </span>
                </div>
                
              </v-col>
              
              <!-- <v-col cols="2"></v-col>
              <v-col cols="2"></v-col>
              <v-col cols="2"></v-col> -->
              <v-col v-if="allAccess" cols="2"></v-col><!-- Lisätiedot -->
            </v-row>
            <div v-for="(pvId) in Object.keys(p.productVariations)" :key="'pv-'+pvId" style="width:100%;" >
              <div v-if="!showOnlyUnderAvecorStockNotifyLevel || (showOnlyUnderAvecorStockNotifyLevel && pvsUnderAvecorStockNotifyLevel.includes(pvId))">
                <div 
                  :key="keysObj[pvId] ? 'pv-row-'+pvId +'-'+ keysObj[pvId] : 'pv-row-'+pvId"
                  style="border:1px dotted #ccc" class="ml-10 mr-2 my-1" 
                  v-if="(selectedWarehouseTab === 'warehouse' && selectedWarehouse === 'avecor' && p.productVariations[pvId].warehoused) ||
                    (selectedWarehouseTab === 'campaignProducts' && selectedWarehouse === 'avecor' && p.productVariations[pvId].warehoused && p.productVariations[pvId].campaigned) || 
                    (selectedWarehouseTab === 'warehouse' && selectedWarehouse !== 'avecor' && p.productVariations[pvId].customersWarehoused[selectedWarehouse] && p.productVariations[pvId].customersWarehoused[selectedWarehouse].warehoused)">
                  
                    <v-row  class="" no-gutters  style="width:100%;"  >
                      <v-col :cols="3" class="pl-2" > <!-- NIMI -->
                        <div class="stock-custom-field">
                          <div>
                            <b>Variaatio: </b>{{p.productVariations[pvId].name}}
                          </div>
                          <div v-if="allAccess">
                            <b>Varastotuote: </b>
                            <span class="mr-1" >
                              <span v-if="selectedWarehouse === 'avecor'">
                                <v-icon v-if="p.productVariations[pvId].warehoused" style="cursor:pointer;z-index:1 !important" size="12" @mouseup.stop="saveWarehousedStatus(selectedWarehouse,pvId,false);saveCampaignedStatus(selectedWarehouse,pvId,false)" color="green">fas fa-check-square</v-icon>
                                <v-icon v-else @mouseup.stop="saveWarehousedStatus(selectedWarehouse,pvId,true)" style="cursor:pointer" size="12" color="grey">far fa-square</v-icon>
                              </span>
                              <span v-else>
                                <v-icon v-if="p.productVariations[pvId].customersWarehoused[selectedWarehouse] && p.productVariations[pvId].customersWarehoused[selectedWarehouse].warehoused" style="cursor:pointer;z-index:1 !important" size="12" @mouseup.stop="saveWarehousedStatus(selectedWarehouse,pvId,false);saveCampaignedStatus(selectedWarehouse,pvId,false)" color="green">fas fa-check-square</v-icon>
                                <v-icon v-else @mouseup.stop="saveWarehousedStatus(selectedWarehouse,pvId,true)" style="cursor:pointer" size="12" color="grey">far fa-square</v-icon>
                              </span>
                            </span>
                          </div>
                          <div class="">
                            <b>Kampanjatuote: </b>
                            <span class="mr-1" v-if="allAccess">
                              <span v-if="selectedWarehouse === 'avecor'">
                                <v-icon v-if="p.productVariations[pvId].campaigned" style="cursor:pointer;z-index:1 !important" size="12" @mouseup.stop="saveCampaignedStatus(selectedWarehouse,pvId,false)" color="green">fas fa-check-square</v-icon>
                                <v-icon v-else @mouseup.stop="saveCampaignedStatus(selectedWarehouse,pvId,true)" style="cursor:pointer" size="12" color="grey">far fa-square</v-icon>
                              </span>
                            </span>
                            <span class="mr-1" v-else>
                              <span v-if="selectedWarehouse === 'avecor'">
                                <v-icon v-if="p.productVariations[pvId].campaigned" size="12" color="green">fas fa-check-square</v-icon>
                                <v-icon v-else size="12" color="grey">far fa-square</v-icon>
                              </span>
                            </span>
                          </div>
                          <div style="cursor:pointer !important;" @click="copyToClipboard(p.productVariations[pvId].avecorSku)"><b>Tuotekoodi: </b>{{p.productVariations[pvId].avecorSku}}</div>
                          <!-- <div v-if="allAccess">
                            <b>Vähennä myös merkkaamon saldoa: </b>
                            <v-icon v-if="p.productVariations[pvId].subtractAlsoPrintShopStock" style="cursor:pointer;z-index:1 !important" size="12" @mouseup.stop="saveProductVariationUpdate(pvId,'subtractAlsoPrintShopStock',false)" color="green">fas fa-check-square</v-icon>
                            <v-icon v-else @mouseup.stop="saveProductVariationUpdate(pvId,'subtractAlsoPrintShopStock',true)" style="cursor:pointer" size="12" color="grey">far fa-square</v-icon>
                          </div> -->
                          <div v-if="allAccess">
                            <b>Hälytysraja aktiivinen: </b>
                            <v-icon v-if="p.productVariations[pvId].sendAvecorStockNotifyEmail" style="cursor:pointer;z-index:1 !important" size="12" @mouseup.stop="saveProductVariationUpdate(pvId,'sendAvecorStockNotifyEmail',false)" color="green">fas fa-check-square</v-icon>
                            <v-icon v-else @mouseup.stop="saveProductVariationUpdate(pvId,'sendAvecorStockNotifyEmail',true)" style="cursor:pointer" size="12" color="grey">far fa-square</v-icon>
                          </div>
                          <!-- <div><b>Lavapaikka: </b>{{p.productVariations[pvId].shelfLocation.toString()}}</div> -->
                        </div>
                      </v-col>
                      <!-- AVECOR SALDO -->
                      <v-col cols="4">
                        <v-row no-gutters>
                          
                          <!-- VARAUKSESS -->
                          <v-col :cols="4" v-if="newVersion"> 
                            
                            <!-- <div style="font-weight:600;font-size:12px;" class="pt-10 stock-custom-field non-editable">{{getTotalStock(p.productVariations[pvId].batches, 'avecor') }}</div> -->
                            <v-text-field
                              v-if="selectedWarehouse === 'avecor' && allAccess"
                              :key="'available_update_'+pvId+available_product_ref_counter"
                              :value="reserved[selectedWarehouse] && reserved[selectedWarehouse][p.id] && reserved[selectedWarehouse][p.id].variations && reserved[selectedWarehouse][p.id].variations[pvId] && reserved[selectedWarehouse][p.id].variations[pvId].total ? p.productVariations[pvId].avecorStock - reserved[selectedWarehouse][p.id].variations[pvId].total : p.productVariations[pvId].avecorStock" 
                              @change="v => updateStockBasedOnAvailable(p, p.id, selectedWarehouse, pvId, v)"
                              class="avecor-select"
                              :style="getStylesForAvailableField(p,pvId)"
                              autocomplete="off"
                              :readonly="!allAccess"
                              hide-details
                            ></v-text-field>
                            <v-text-field
                              v-if="selectedWarehouse === 'avecor' && (!allAccess || user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2')"
                              :key="'available_update2_'+pvId+available_product_ref_counter"
                              :value="productVariations[pvId].reservedAvecor ? p.productVariations[pvId].avecorStock - productVariations[pvId].reservedAvecor : p.productVariations[pvId].avecorStock" 
                              
                              class="avecor-select"
                              :style="getStylesForAvailableField(p,pvId)"
                              autocomplete="off"
                              :readonly="!allAccess"
                              hide-details
                            ></v-text-field>

                            <v-text-field
                              v-if="selectedWarehouse === 'avecor' && selectedWarehouseTab === 'warehouse' && allAccess"
                              :readonly="!allAccess"
                              :value="p.productVariations[pvId].avecorStockNotifyLevel"
                              @change="v => saveProductVariationUpdate(pvId,'avecorStockNotifyLevel',v)"
                              class="avecor-select avecor-stock-notify-input"
                              :style="p.productVariations[pvId].sendAvecorStockNotifyEmail && p.productVariations[pvId].avecorStockNotifyLevel ? 'background:#AED581;!important;padding-left:20px; margin-right:20px;' : 'background:#FFE0B2 !important;padding-left:20px; margin-right:20px;'"
                              autocomplete="off"
                              label="Hälytysraja"
                              hide-details
                            ></v-text-field>
                          </v-col>
                          <!-- KESKENERÄISET -->
                          <!-- <v-col :cols="2" v-if="!newVersion"> 
                            <v-text-field
                              v-if="selectedWarehouse === 'avecor'"
                              :disabled="true"
                              :value="incompletes[selectedWarehouse] && incompletes[selectedWarehouse][p.id] && incompletes[selectedWarehouse][p.id].variations && incompletes[selectedWarehouse][p.id].variations[pvId] ? incompletes[selectedWarehouse][p.id].variations[pvId] : 0" 
                              @change="v => saveProductVariationUpdate(pvId,'avecorStock',v)"
                              class="avecor-select"
                              style="background:#eee !important;padding-left:20px; margin-right:20px;"
                              autocomplete="off"
                              hide-details
                            ></v-text-field>
                          </v-col> -->
                          <!-- RESERVED -->
                          <v-col :cols="4"> 
                            <!-- <div style="font-weight:600;font-size:12px;" class="pt-10 stock-custom-field non-editable">{{getTotalStock(p.productVariations[pvId].batches, 'avecor') }}</div> -->
                            <v-text-field
                              v-if="selectedWarehouse === 'avecor' && allAccess"
                              :disabled="true"
                              :value="reserved[selectedWarehouse] && reserved[selectedWarehouse][p.id] && reserved[selectedWarehouse][p.id].variations && reserved[selectedWarehouse][p.id].variations[pvId] && reserved[selectedWarehouse][p.id].variations[pvId].total ? reserved[selectedWarehouse][p.id].variations[pvId].total : 0" 
                              class="avecor-select"
                              style="background:#eee !important;padding-left:20px; margin-right:5px;display:inline-block;width:70%;"
                              autocomplete="off"
                              hide-details
                            ></v-text-field>
                            <v-text-field
                              v-if="selectedWarehouse === 'avecor' && (!allAccess || user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2') "
                              :disabled="true"
                              :value="productVariations[pvId].reservedAvecor ? productVariations[pvId].reservedAvecor : 0" 
                              class="avecor-select"
                              style="background:#eee !important;padding-left:20px; margin-right:5px;display:inline-block;width:70%;"
                              autocomplete="off"
                              hide-details
                            ></v-text-field>
                            <!-- style="background:#eee !important;padding-left:20px; margin-right:20px;color:#FFF !important;" -->
                            <v-menu v-if="selectedWarehouse === 'avecor' && allAccess" open-on-hover bottom offset-y nudge-bottom="10" close-delay="100" >
                              <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on" @mouseover="v => menuActive = pvId">
                                  <i  class="fas fa-info-circle" style="font-size:10px;margin-right:10px;"></i>
                                </span>
                              </template>
                              <div style="font-size:11px;background:#FFF;padding:10px;" v-if="selectedWarehouse === 'avecor'">
                                <div style="font-weight:600;font-size:13px;">Tilaukset</div>
                                <br>
                                <div v-if="menuActive === pvId && reserved[selectedWarehouse] && reserved[selectedWarehouse][p.id] && reserved[selectedWarehouse][p.id].variations && reserved[selectedWarehouse][p.id].variations[pvId] && reserved[selectedWarehouse][p.id].variations[pvId].total">
                                  <div style="font-weight:600;border-bottom:1px solid #ccc;">
                                    <div style="display:inline-block;width:20px;"></div>
                                    <div style="display:inline-block;width:100px;">Luotu pvm</div>
                                    <div style="display:inline-block;width:200px;">Yrityksen nimi</div>
                                    <div style="display:inline-block;width:100px;">Tilattu määrä</div>
                                    <div style="display:inline-block;width:60px;">Mallit</div>
                                    <div style="display:inline-block;width:100px;">Saldoa laskettu määrä</div>
                                    <div style="display:inline-block;width:175px;">Saldon status tilaukselle</div>
                                    <div style="display:inline-block;width:100px;">Saldoa jäljellä varuksen jälkeen</div>
                                    <div style="display:inline-block;width:150px;">Status</div>
                                    <div style="display:inline-block;width:125px;">Laskutus status</div>
                                    <div style="display:inline-block;width:75px;">Netvisor id</div>
                                  </div>
                                  <div v-for="(op,i) in reserved[selectedWarehouse][p.id].variations[pvId].details" :key="pvId+'_reservation_details_'+i" style="border-bottom:1px solid #ccc;height:22px;padding-top:3px;" >
                                    <div style="display:inline-block;width:20px;overflow-x:hidden">
                                      <v-icon v-if="op.orderId" :size="9" @click="selectedOrderOrderId = op.orderId;selectedWholesaleCompanyId=null;selectedProductId=null;" style="padding-right:3px;">far fa-eye</v-icon>
                                    </div>
                                    <div style="display:inline-block;width:100px;overflow-x:hidden">{{op.orderedDate}}</div>
                                    <div style="display:inline-block;width:200px;overflow-x:hidden">{{op.companyName}}</div>
                                    <div style="display:inline-block;width:100px;overflow-x:hidden">{{op.orderQuantity}}</div>
                                    <div style="display:inline-block;width:60px;overflow-x:hidden">{{op.numberOfSamples}}</div>
                                    <div style="display:inline-block;width:100px;overflow-x:hidden">{{op.quantity}}</div>
                                    
                                    <div style="display:inline-block;width:175px;overflow-x:hidden">
                                      <div v-if="settings.orderedProductStockStatusObject[op.stockStatus]">
                                        <i class="fas fa-circle" :style="' font-size:10px;margin-right:5px;color:'+settings.orderedProductStockStatusObject[op.stockStatus].color"></i>
                                        <span>{{settings.orderedProductStockStatusObject[op.stockStatus].text}}</span>
                                      </div>
                                    </div>
                                    <div style="display:inline-block;width:100px;overflow-x:hidden">{{op.stockAvailable}}</div>
                                    
                                    <div style="display:inline-block;width:150px;overflow-x:hidden">{{op.orderStatusText}}</div>
                                    <div style="display:inline-block;width:125px;overflow-x:hidden">{{op.orderInvoiceStatusText}}</div>
                                    <div style="display:inline-block;width:75px;overflow-x:hidden">{{op.netvisorId}}</div>
                                    
                                  </div>
                                </div>
                                <div v-else class="text-center my-5">
                                  <span style="font-weight:600">Ei varauksessa olevia tuotetilauksia.</span>
                                </div>
                              </div>
                            </v-menu>
                            <!-- <v-text-field
                              v-if="selectedWarehouse === 'avecor'"
                              :disabled="true"
                              :value="reserved[selectedWarehouse] && reserved[selectedWarehouse][p.id] && reserved[selectedWarehouse][p.id].variations && reserved[selectedWarehouse][p.id].variations[pvId] ? reserved[selectedWarehouse][p.id].variations[pvId] : 0" 
                              @change="v => saveProductVariationUpdate(pvId,'avecorStock',v)"
                              class="avecor-select"
                              style="background:#eee !important;padding-left:20px; margin-right:20px;"
                              autocomplete="off"
                              hide-details
                            ></v-text-field> -->
                          </v-col>
                          <v-col :cols="4"> 
                            <!-- <div style="font-weight:600;font-size:12px;" class="pt-10 stock-custom-field non-editable">{{getTotalStock(p.productVariations[pvId].batches, 'avecor') }}</div> -->
                            <span>
                              <v-text-field
                                v-if="selectedWarehouse === 'avecor'"
                                :readonly="!allAccess"
                                :value="p.productVariations[pvId].avecorStock"
                                @change="v => saveProductVariationUpdate(pvId,'avecorStock',v)"
                                class="avecor-select"
                                style="background:#eee !important;padding-left:20px; margin-right:5px;display:inline-block;width:70%;"
                                autocomplete="off"
                                hide-details
                              ></v-text-field>
                              <v-menu open-on-hover bottom offset-y nudge-bottom="10" close-delay="200" >
                                <template v-slot:activator="{ on, attrs }">
                                  <span v-bind="attrs" v-on="on" >
                                    <i v-if="selectedWarehouse === 'avecor'" class="fas fa-info-circle" style="font-size:10px;margin-right:10px;"></i>
                                  </span>
                                </template>
                                <div style="font-size:11px;background:#FFF;padding:10px;" v-if="selectedWarehouse === 'avecor'">
                                  <div style="font-weight:600;font-size:13px;">Tilatut tuotteet</div>
                                  <br>
                                  <div v-if="logsMap[pvId] && logsMap[pvId].avecorStockUpdates" style="max-height:600px;overflow-y:scroll;" class="logs-scrollbar">
                                    <div style="font-weight:600;border-bottom:1px solid #ccc;margin-bottom:3px;">
                                      <div style="display:inline-block;width:20px;"></div>
                                      <div style="display:inline-block;width:100px;">Muutos pvm</div>
                                      <div style="display:inline-block;width:50px;">Henkilö</div>
                                      <div style="display:inline-block;width:300px;">Muutoksen tyyppi</div>
                                      <div style="display:inline-block;width:70px;">Uusi saldo</div>
                                      <div style="display:inline-block;width:70px;">Vanha saldo</div>
                                      <div style="display:inline-block;width:70px;">Muutos</div>
                                      <div style="display:inline-block;width:20px;"></div>
                                      <div style="display:inline-block;width:100px;">Tilaus pvm</div>
                                      <div style="display:inline-block;width:150px;">Yrityksen nimi</div>
                                      <div style="display:inline-block;width:75px;">Netvisor id</div>
                                    </div>
                                    <div v-for="(u,index) in logsMap[pvId].avecorStockUpdates.slice().reverse()" :key="pvId+'_avecorStock_updates'+index" style="border-bottom:1px solid #ccc;">
                                      <div style="display:inline-block;width:20px;">
                                        <v-icon v-if="u.orderId" :size="9" @click="selectedOrderOrderId = u.orderId;selectedWholesaleCompanyId=null;selectedProductId=null;" style="padding-right:3px;">far fa-eye</v-icon>
                                      </div>
                                      <div style="display:inline-block;width:100px;">{{customFormatter(u.date)}}</div>
                                      <div style="display:inline-block;width:50px;">{{staff[u.userId].firstName}}</div>
                                      <div style="display:inline-block;width:300px;">
                                        <span v-if="u.changeType === 'updatedStockField'">Saldo kentän päivitys</span>
                                        <span v-if="u.changeType === 'updatedAvailableStockField'">Saldo päivitys (saatavilla kentän kautta)</span>
                                        
                                        <span v-if="u.changeType === 'movedOutOfProductShippedStatus'">Tuotetilaus siirretty pois lähetetty asiakkaalle statuksesta</span>
                                        <span v-if="u.changeType === 'movedToProductShippedStatus'">Siirretty lähetetty asiakkaalle statukseen</span>
                                        <span v-if="u.changeType === 'batchShelfed'">Erä hyllytetty</span>
                                        <span v-if="u.changeType === 'batchUnshelfed'">Erä poistettu hyllystä</span>
                                        
                                        
                                      </div>
                                      <div style="display:inline-block;width:70px;font-weight:600">{{u.newStock}}</div>
                                      <div style="display:inline-block;width:70px;">{{u.previousStock}}</div>
                                      <div style="display:inline-block;width:70px;">
                                        <span v-if="!isNaN(Number(u.changeAmount)) && Number(u.changeAmount) >= 0" style="color:green;">+{{u.changeAmount}}</span>
                                        <span v-else-if="!isNaN(Number(u.changeAmount)) && Number(u.changeAmount) < 0" style="color:red;">{{u.changeAmount}}</span>
                                        <span v-else style="color:black">{{u.changeAmount}}</span>
                                      </div>
                                      <div style="display:inline-block;width:20px;"></div>
                                      <div style="display:inline-block;width:100px;">{{orders[u.orderId] && orders[u.orderId].created_at ? customFormatter(orders[u.orderId].created_at) : ''}}</div>
                                      <div style="display:inline-block;width:150px;">{{orders[u.orderId] && orders[u.orderId].companyId && companies[orders[u.orderId].companyId] ? companies[orders[u.orderId].companyId].companyName : ''}}</div>
                                      <div style="display:inline-block;width:75px;">{{orders[u.orderId] && orders[u.orderId].netvisorId ? orders[u.orderId].netvisorId : '' }}</div>
                                      
                                    </div>
                                  </div>
                                  <div v-else class="text-center my-5">
                                    <span style="font-weight:600">Ei historiaa saldomuutoksista vielä.</span>
                                  </div>
                                </div>
                              </v-menu>
                              
                            </span>
                            <v-text-field
                              v-if="selectedWarehouse !== 'avecor'"
                              :readonly="!allAccess"
                              :value="p.productVariations[pvId].customersWarehoused[selectedWarehouse].avecorStock"
                              @change="v => saveCustomerWarehouseUpdate(selectedWarehouse,pvId,'avecorStock',v)"
                              class="avecor-select"
                              style="background:#eee !important;padding-left:20px; margin-right:20px;"
                              autocomplete="off"
                              hide-details
                            ></v-text-field>
                            
                          </v-col>
                          <!-- MERKKAAMO SALDO -->
                          <!-- <v-col :cols="3"> 
                            <v-text-field
                              v-if="selectedWarehouse === 'avecor'"
                              :readonly="!allAccess"
                              :value="p.productVariations[pvId].printShopStock"
                              @change="v => saveProductVariationUpdate(pvId,'printShopStock',v)"
                              class="avecor-select"
                              style="background:#eee !important;padding-left:20px; margin-right:20px;"
                              autocomplete="off"
                              hide-details
                            ></v-text-field>
                          </v-col> -->
                        </v-row>
                      </v-col>
                      <!-- OSTOHINTA -->
                      <!-- MYYNTIHINTA -->
                      <v-col :cols="allAccess ? 1 : 2"> 
                        <!-- EDITABLE -->
                        <v-text-field
                          v-if="!p.productVariations[pvId].isUnitSalesPriceFromPrices"
                          :disabled="selectedWarehouse !== 'avecor'"
                          :readonly="!allAccess"
                          :value="p.productVariations[pvId].unitSalesPrice"
                          @change="v => saveProductVariationUpdate(pvId,'unitSalesPrice',v)"
                          class="avecor-select"
                          style="background:#eee !important;padding-left:20px; margin-right:20px;"
                          autocomplete="off"
                          hide-details
                        ></v-text-field>
                        <v-menu
                          v-else
                          :nudge-right="0"
                          transition="fade-transition"
                          offset-y
                          open-on-hover
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <v-text-field
                                :disabled="true"
                                :readonly="true"
                                :value="p.productVariations[pvId].unitSalesPrice"
                                class="avecor-select"
                                style="background:#eee !important;padding-left:20px; margin-right:20px;"
                                autocomplete="off"
                                hide-details
                              ></v-text-field>
                            </span>
                          </template>
                          <div class="pa-3" style="font-size:10px;">Tuotu hinnastosta.</div>
                        </v-menu>
                      </v-col>
                      <v-col v-if="allAccess" :cols="1"> 
                        <v-text-field
                          v-if="!p.productVariations[pvId].isUnitSalesPriceFromPrices"
                          :disabled="selectedWarehouse !== 'avecor'"
                          :readonly="!allAccess"
                          :value="p.productVariations[pvId].unitPurchasePrice"
                          @change="v => saveProductVariationUpdate(pvId,'unitPurchasePrice',v)"
                          class="avecor-select"
                          style="background:#eee !important;padding-left:20px; margin-right:20px;"
                          autocomplete="off"
                          hide-details
                        ></v-text-field>
                        <v-menu
                          v-else
                          :nudge-right="0"
                          transition="fade-transition"
                          offset-y
                          open-on-hover
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <v-text-field
                                :disabled="true"
                                :readonly="true"
                                :value="p.productVariations[pvId].unitPurchasePrice"
                                class="avecor-select"
                                style="background:#eee !important;padding-left:20px; margin-right:20px;"
                                autocomplete="off"
                                hide-details
                              ></v-text-field>
                            </span>
                          </template>
                          <div class="pa-3" style="font-size:10px;">Tuotu hinnastosta.</div>
                        </v-menu>
                      </v-col>
                      <v-col :cols="3" class="pr-2"> 
                        <v-textarea
                          :disabled="selectedWarehouse !== 'avecor'"
                          :readonly="!allAccess"
                          :value="p.productVariations[pvId].commentsForSales"
                          @change="v => saveProductVariationUpdate(pvId,'commentsForSales',v)"
                          single-line
                          style="background:#eee !important;padding:5px;margin-bottom:0px;"
                          rows="1"
                          :auto-grow="autogrow"
                          hide-details=""
                          class="avecor-select avecor-textarea"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  
                  <!-- BATCH INFO -->
                  <v-row no-gutters v-if="showBatchInformation && selectedWarehouse === 'avecor' && selectedWarehouseTab === 'warehouse'" :class="Object.keys(p.productVariations[pvId].batches).length == 0 ? 'pb-2' : ''">
                    <!-- <v-col class="orders-custom-header pr-1" style="max-width:30px;" cols="1"></v-col> -->
                    <v-col class="stock-batch-fields pl-2" cols="3" >
                      <span><b>Erät</b>
                        <v-btn x-small @click="newBatchModalVisible = true; newBatchModalProductId = p.id;newBatchModalProductVariationId = pvId " class="add-button avecor-button-global ml-4" style="height:15px !important;font-size:8px !important;">Lisää erä</v-btn>
                      </span>
                    </v-col>
                  </v-row>
                  <div v-if="p.productVariations[pvId].batches && Object.keys(p.productVariations[pvId].batches).length > 0 && showBatchInformation && selectedWarehouse === 'avecor' && selectedWarehouseTab === 'warehouse'" class="pb-2 stock-batch-fields" >
                    
                    <v-row :key="'b-'+batch.id"  no-gutters  v-for="batch in getSortedBatches(p.productVariations[pvId].batches)">
                      
                      <!-- <v-col class="orders-custom-header pr-1" style="max-width:30px;" cols="1"></v-col> -->
                      <v-col cols="6" class="pl-2" >
                        <!-- <v-icon v-if="batch.id === 'unallocated'" :color="'#ff2f00'" :size="10" style="padding-right:5px;">fas fa-square-full</v-icon> -->
                        <v-icon 
                          :color="batch.batchArrivalDateStatus ? settings.batchArrivalDateStatusColors[batch.batchArrivalDateStatus] : '#ccc'"
                          :size="10"
                          style="padding-right:5px;"
                        >fas fa-square-full</v-icon>
                        <!-- <span v-if="batch.id === 'unallocated'"><span style="display: inline-block;width:75px;margin-right:1em">Puuttuu</span></span> -->
                        <!-- <span v-if="batch.status === 'batchArrivedToWarehouse' || batch.status === 'batchShelfed'">
                          <span style="display: inline-block;width:80px;margin-right:1em">
                            <span v-if="batch.stockLocation === 'avecor' && allAccess">A-Varastossa</span>
                            <span v-else-if="batch.stockLocation === 'printShop' && allAccess">M-Varastossa</span>
                            <span v-else>Varastossa</span>
                          </span>  
                        </span> -->
                        
                        <div style="width:80px;display:inline-block">
                          <span v-if="batch.stockLocation === 'avecor' && allAccess">Avecor Varasto</span>
                          <span v-else-if="batch.stockLocation === 'printShop' && allAccess">Merkka. Varasto</span>
                        </div>
                        <span style="width:100px;display:inline-block">
                          <v-autocomplete
                            autocomplete="off"
                            :value="batch.status"
                            :items="settings.batchStatusArray"
                            @change="v => editBatch(v, 'status', pvId, batch.id)"
                            persistent-hint
                            item-text="text"
                            item-value="id"
                            hide-details
                            class="avecor-select pl-4"
                            style="display:inline-block; width:100px;"
                          />
                        </span>
                        <span style="width:50px;display:inline-block"> 
                          <v-text-field
                            :value="batch.quantity"
                            @change="v => editBatch(v, 'quantity', pvId, batch.id)"
                            label="Määrä"
                            class="avecor-select hide-field-details ml-2 pl-2 warehouse-table-field "
                            style="background:#EEE;display:inline-block;width:75px"
                          ></v-text-field>
                        </span>
                        <!-- <span style="width:75px;display:inline-block"> 
                          <v-menu
                            :nudge-right="80"
                            transition="fade-transition"
                            offset-y
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                label="Tilauspäivä"
                                v-on="on"
                                v-model="batch.orderDate"
                                readonly
                                class="avecor-select hide-field-details warehouse-table-field ml-4 pl-2"
                                style="background:#EEE;display:inline-block;width:75px"
                              ></v-text-field>
                            </template>
                            <v-date-picker @change="v => editBatch(v, 'orderDate', pvId, batch.id)" :value="batch.orderDate" locale="fi-fi" ></v-date-picker>
                          </v-menu>
                        </span> -->
                      <!--  <span style="width:75px;display:inline-block"> 
                          <v-menu
                            :nudge-right="80"
                            transition="fade-transition"
                            offset-y
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                label="Arvioitu saapumispäivä"
                                v-on="on"
                                v-model="batch.estimatedArrivalDate"
                                readonly
                                class="avecor-select hide-field-details warehouse-table-field ml-4 pl-2"
                                style="background:#EEE;display:inline-block;width:75px"
                              ></v-text-field>
                            </template>
                            <v-date-picker @change="v => editBatch(v, 'estimatedArrivalDate', pvId, batch.id)" :value="batch.estimatedArrivalDate" locale="fi-fi" ></v-date-picker>
                          </v-menu>
                        </span> -->
                      
                        <!-- Erän saapumiset -->
                        <span >
                          <v-menu
                            :nudge-right="80"
                            transition="fade-transition"
                            offset-y
                            style="background:#FFF;display:inline-block;"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-on="on"
                                v-model="batch.orderDate"
                                readonly
                                label="Tilauspäivä"
                                class="avecor-select hide-field-details ml-2 pl-2 warehouse-table-field"
                                style="background:#EEE;display:inline-block;width:75px"
                              ></v-text-field>
                            </template>
                            <v-date-picker @change="v => editBatch(v, 'orderDate', pvId, batch.id)" :value="batch.orderDate" locale="fi-fi"></v-date-picker>
                          </v-menu>
                        </span>
                        <span v-if="batch.status !== 'batchArrivedToWarehouse' && batch.status !== 'batchShelfed' && batch.status !== 'batchPartiallyShelfed'">
                          <v-menu
                            :nudge-right="80"
                            transition="fade-transition"
                            offset-y
                            style="background:#FFF;display:inline-block;"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-on="on"
                                v-model="batch.estimatedArrivalDate"
                                readonly
                                label="Arvioitu saapumispäivä"
                                class="avecor-select hide-field-details ml-2 pl-2 warehouse-table-field"
                                style="background:#EEE;display:inline-block;width:75px"
                              ></v-text-field>
                            </template>
                            <v-date-picker @change="v => editBatch(v, 'estimatedArrivalDate', pvId, batch.id)" :value="batch.estimatedArrivalDate" locale="fi-fi"></v-date-picker>
                          </v-menu>
                        </span>
                        <span v-else>
                          <!-- FIRST PART OF BATCH -->
                          <div class="my-2">
                            <span> 
                              <v-text-field
                                :value="batch.quantityArrived"
                                @change="v => editBatch(v, 'quantityArrived', pvId, batch.id)"
                                label="Osa 1 - Saapunut määrä"
                                class="avecor-select hide-field-details ml-4 pl-2 warehouse-table-field "
                                style="background:#EEE;display:inline-block;width:125px"
                              ></v-text-field>
                            </span>
                            <span>
                              <v-menu
                                :nudge-right="80"
                                transition="fade-transition"
                                offset-y
                                style="background:#FFF;display:inline-block;"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    v-on="on"
                                    v-model="batch.arrivalDate"
                                    readonly
                                    label="Osa 1 - Saapumispäivä"
                                    placeholder=" "
                                    class="avecor-select hide-field-details ml-2 pl-2 warehouse-table-field"
                                    style="background:#EEE;display:inline-block;"
                                  ></v-text-field>
                                </template>
                                <v-date-picker @change="v => editBatch(v, 'arrivalDate', pvId, batch.id)" :value="batch.arrivalDate" locale="fi-fi"></v-date-picker>
                              </v-menu>
                            </span>
                          </div>
                          <!-- SECOND PART  -->
                          <div class="mb-2" v-if="showFieldsForBatchPart(batch,2)">
                            <span> 
                              <v-text-field
                                :value="batch.quantityArrived2"
                                @change="v => editBatch(v, 'quantityArrived2', pvId, batch.id)"
                                label="Osa 2 - Saapunut määrä"
                                class="avecor-select hide-field-details ml-4 pl-2 warehouse-table-field "
                                style="background:#EEE;display:inline-block;width:125px"
                              ></v-text-field>
                            </span>
                            <span>
                              <v-menu
                                :nudge-right="80"
                                transition="fade-transition"
                                offset-y
                                style="background:#FFF;display:inline-block;"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    v-on="on"
                                    v-model="batch.arrivalDate2"
                                    readonly
                                    label="Osa 2 - Saapumispäivä"
                                    placeholder=" "
                                    class="avecor-select hide-field-details ml-2 pl-2 warehouse-table-field"
                                    style="background:#EEE;display:inline-block;"
                                  ></v-text-field>
                                </template>
                                <v-date-picker @change="v => editBatch(v, 'arrivalDate2', pvId, batch.id)" :value="batch.arrivalDate2" locale="fi-fi"></v-date-picker>
                              </v-menu>
                            </span>
                          </div>
                          <!-- THIRD PART  -->
                          <div class="mb-2" v-if="showFieldsForBatchPart(batch,3)">
                            <span> 
                              <v-text-field
                                :value="batch.quantityArrived3"
                                @change="v => editBatch(v, 'quantityArrived3', pvId, batch.id)"
                                label="Osa 3 - Saapunut määrä"
                                class="avecor-select hide-field-details ml-4 pl-2 warehouse-table-field "
                                style="background:#EEE;display:inline-block;width:125px"
                              ></v-text-field>
                            </span>
                            <span>
                              <v-menu
                                :nudge-right="80"
                                transition="fade-transition"
                                offset-y
                                style="background:#FFF;display:inline-block;"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    v-on="on"
                                    v-model="batch.arrivalDate3"
                                    readonly
                                    label="Osa 3 - Saapumispäivä"
                                    placeholder=" "
                                    class="avecor-select hide-field-details ml-2 pl-2 warehouse-table-field"
                                    style="background:#EEE;display:inline-block;"
                                  ></v-text-field>
                                </template>
                                <v-date-picker @change="v => editBatch(v, 'arrivalDate3', pvId, batch.id)" :value="batch.arrivalDate3" locale="fi-fi"></v-date-picker>
                              </v-menu>
                            </span>
                          </div>
                        </span>
                      </v-col>
                      <!-- @change="v => saveProductVariationUpdate(pvId,'commentsForSales',v)" -->
                      <v-col cols="6" class="pl-2 pr-2" >
                        <div class="non-editable" v-if="allAccess" style="width:100%;">
                          <v-textarea
                            :disabled="selectedWarehouse !== 'avecor'"
                            :readonly="!allAccess"
                            :value="batch.officeComments"
                            label="Erän kommentit (o)"
                            style="background:#eee !important;margin-bottom:0px;display:inline-block;width:100%;"
                            rows="2"
                            :auto-grow="autogrow"
                            @change="v => editBatch(v, 'officeComments', pvId, batch.id)"
                            hide-details
                            class="avecor-select avecor-textarea pl-2 warehouse-table-field"
                          ></v-textarea>
                        </div>
                      </v-col>
                      <v-col cols="2" class="pl-2" ></v-col>
                      <!-- <v-col cols="1"> 
                        <div v-if="batch.status !== undefined" class="stock-custom-field non-editable">{{ getOrderableInBatch(batch)}}</div>
                        <div v-else-if="batch.id === 'unallocated'" class="stock-custom-field non-editable">{{ -(batch.reservations.avecor.total+batch.reservations.printShop.total)}}</div>
                      </v-col>
                      <v-col cols="1"> 
                        <div class="stock-custom-field non-editable">{{ batch.expiryDate}}</div>
                      </v-col>
                      <v-col v-if="allAccess" cols="1"> 
                        <div v-if="batch.stockLocation === 'avecor'" class="stock-custom-field non-editable">{{ getStockInBatch(batch) }}</div>
                        <div v-else-if="batch.id === 'unallocated'" class="stock-custom-field non-editable">{{-batch.reservations.avecor.total}}</div>
                        <div v-else class="stock-custom-field non-editable">0</div>
                      </v-col>
                      <v-col v-if="allAccess" cols="1"> 
                        <div v-if="batch.stockLocation === 'printShop'" class="stock-custom-field non-editable">{{ getStockInBatch(batch)}}</div>
                        <div v-else-if="batch.id === 'unallocated'" class="stock-custom-field non-editable">{{-batch.reservations.printShop.total}}</div>
                        <div v-else class="stock-custom-field non-editable">0</div>
                      </v-col> -->
                      <!-- <v-col v-if="allAccess" cols="3">
                        <div class="stock-custom-field non-editable">
                          <span>{{batch.officeComments}}</span>
                        </div>
                      </v-col> -->
                    </v-row>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="5" class="pl-3">
            <v-row no-gutters>
              <!-- TUOTE LISÄTIEDOT -->
              <!-- <v-col :cols="allAccess ? 3 : 8" class="pl-0"> 
                <div 
                  v-if="!allAccess"
                  class="stock-custom-field">
                  {{p.productInformation}}
                </div>
                <v-textarea
                  v-if="allAccess"
                  :value="p.productInformation"
                  @change="v => saveProductUpdate(p.id,'productInformation',v)"
                  class="avecor-select"
                  :auto-grow="true"
                  rows=2
                  hide-details
                  autocomplete="off"
                ></v-textarea>  
              </v-col> -->
              <!-- VARASTO LISÄTIEDOT -->
              <v-col v-if="allAccess" cols="4" class="pl-0"> 
                <v-textarea
                  :value="p.warehouseInformation"
                  @change="v => saveProductUpdate(p.id,'warehouseInformation',v)"
                  class="avecor-select"
                  :auto-grow="true"
                  rows=2
                  hide-details
                  autocomplete="off"
                ></v-textarea>  
              </v-col>
              <!-- PARASTA ENNEN -->
              <!-- <v-col cols="1" class="pl-0"> 
                <span style="font-size:10px;">Anu selvittää miten tämä logataan</span>
                <v-menu
                  :nudge-right="80"
                  lazy
                  transition="fade-transition"
                  offset-y
                  full-width
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      label="Tilauspäivä"     
                      :value="customFormatter(orders[selectedOrderOrderId].created_at)"
                      readonly
                      class="avecor-select hide-field-details"
                    ></v-text-field>
                  </template>
                  <v-date-picker @change="v => inlineSaveOrderDetails('created_at',v)" :value="customFormatter(orders[selectedOrderOrderId].created_at)" locale="fi-fi"></v-date-picker>
                </v-menu>
              </v-col> -->
              
              <!-- TOIMITUSAIKA -->
              <v-col cols="2" class="pl-0"> 
                <div 
                  v-if="!allAccess"
                  class="stock-custom-field">
                  {{p.deliveryTime}}
                </div>
                <v-textarea
                  v-if="allAccess"
                  :value="p.deliveryTime"
                  @change="v => saveProductUpdate(p.id,'deliveryTime',v)"
                  class="avecor-select"
                  :auto-grow="true"
                  rows=2
                  hide-details
                  autocomplete="off"
                ></v-textarea>  
              </v-col>
              <!-- MERKKAUSTUOTE -->
              <v-col cols="2" class="pl-0"> 
                <div class="stock-custom-field">{{p.isPrintProduct ? "x" : ""}}</div>
              </v-col>
              <!-- TUKKURI -->
              <v-col cols="2" class="pl-0">
                <div 
                  v-if="allAccess"
                  class="stock-custom-field">
                  <v-icon v-if="allAccess" :size="10" @click="selectedWholesaleCompanyId = p.wholesaleCompanyId;selectedProductId = null;selectedOrderOrderId=null" style="padding-right:2px;">far fa-eye</v-icon>
                  {{p.wholesaleCompany}}
                </div>
              </v-col>
              <v-col cols="2" class="pl-0">
                <div 
                  v-if="allAccess"
                  class="stock-custom-field">
                  
                  {{p.printShops.toString()}}
                </div>
              </v-col>
              <!-- <v-col cols="2" class="pl-0">
                <div 
                  v-if="allAccess"
                  class="stock-custom-field">
                  
                  {{p.ordersContactEmail}}
                  <v-btn v-if="p.ordersContactEmail !== undefined && p.ordersContactEmail !== ''" :href="formGmailLink(p.ordersContactEmail)" text target="_blank">
                    <v-icon size=12>fas fa-external-link-alt</v-icon>
                  </v-btn>
                </div>
              </v-col> -->
              
            </v-row>
          </v-col> 
        </v-row>
      </v-lazy>
        
      <!-- <v-row no-gutters style="margin-top:50px;margin-bottom:50px;">
        <v-col cols="12" class="text-center">
          <v-btn v-if="isThereMoreProductsToShow" color="orange" style="color:#fff" @click="productsToShow = productsToShow + productsToShowIncrement">Näytä lisää tuotteita</v-btn>
        </v-col>
      </v-row> -->
    </v-container>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
import firebase from 'firebase'
import axios from 'axios'
import ProductExpand from './ProductExpand'
import WholesaleCompanyExpand from './WholesaleCompanyExpand'
import OrderExpand from './OrderExpand'
import { ExportToCsv } from 'export-to-csv';
import shared from './../../shared'

var db = null

export default {
    components: {
      ProductExpand,
      WholesaleCompanyExpand,
      OrderExpand
    },
    data: () => ({
      showOnlyUnderAvecorStockNotifyLevel:false,
      pvsUnderAvecorStockNotifyLevel:[],
      available_product_ref_counter:10,
      menuActive:'',
      logsMap:{},
      keysObj:{},
      newVersion:true,
      incompletes:{},
      selectedWarehouseTab:'warehouse',
      batchesKey:6545640,
      showBatchInformation:true,
      showShelfedBatches:false,
      showAllBatches:true,
      isWarehouseCustomersSelectionOpen:false,
      isWarehouseProductSelectionOpen:false,
      isThereMoreCompaniesToShow:false,
      isThereMoreProductsToShow:false,
      companiesToShow:250,
      productsToShow:250,
      companiesToShowIncrement:500,
      productsToShowIncrement:500,
      warehouseFilter:'all',
      selectedWarehouse:'avecor',
      productsSearch: '',
      productsSearchInDrawer:'',
      companiesSearchInDrawer:'',
      productsData: {},
      autogrow: true,
      amountOfStockProducts:0,
      totalStockInWarehouse:0,
      totalStockValueInAvecorWarehouse:0,
      totalStockInAvecorWarehouse:0,
      totalStockInPrintShopWarehouse:0,
      totalStockValueInPrintShopWarehouse:0,
      totalStockValueInAvecorWarehouseNEW:0,
      totalStockInAvecorWarehouseNEW:0,
      totalStockInPrintShopWarehouseNEW:0,
      totalStockValueInPrintShopWarehouseNEW:0,
      whichProductsToShow: "active",
      productsToShow:250,
      productsToShowIncrement:500,
      isThereMoreProductsToShow:false,
      numberOfExceededArrivalDates:0,
      numberOfWithin3DaysArrivalDates:0,
      numberOfWithin5DaysArrivalDates:0,
    }),
    created(){
      this.createVariationName = shared.createVariationName
      this.createVariationAvecorSku = shared.createVariationAvecorSku
      this.calculateReserved = shared.calculateReserved
      this.logStockUpdateProductChange = shared.logStockUpdateProductChange
      this.getRange = shared.getRange
    },
    mounted() {
      if(this.isSales) this.showBatchInformation = false
      db = firebase.firestore();
      this.generateProductsData()
      //this.reserved = {}
      this.calculateReserved()
      this.calculateIncompletes()
      this.initiateLogs()
    },
    computed: {
      getAllCompanies(){
        var companies = []
        var t = this
        Object.keys(this.companies).forEach( key => {
          var c = t.companies[key]
          if (this.companiesSearchInDrawer !== ""){
            var productTextsToSearch = ""
            if(c.companyName) productTextsToSearch += c.companyName
            if(c.id) productTextsToSearch += c.id
            if(c.companyId) productTextsToSearch += c.companyId
            if(c.netvisorId) productTextsToSearch += c.netvisorId
            if(productTextsToSearch.toLowerCase().includes(this.companiesSearchInDrawer.toLowerCase())) {
              companies.push({
                name: c.companyName, 
                id: c.id, 
                customerProductsWarehoused:c.customerProductsWarehoused ? c.customerProductsWarehoused : false,
                companyId: c.companyId,
                netvisorId: c.netvisorId,
              })
            }
          }
          else {
            companies.push({
              name: c.companyName, 
              id: c.id, 
              customerProductsWarehoused:c.customerProductsWarehoused ? c.customerProductsWarehoused : false,
              companyId: c.companyId,
              netvisorId: c.netvisorId,
            })
          }
        })
        companies = companies.sort((a,b)=>{
          if(a.name === undefined) return 0
          if(b.name === undefined) return 0
          var nameA=a.name.toLowerCase().trim(), nameB=b.name.toLowerCase().trim();
          if (nameA > nameB) {return 1;}
          if (nameB > nameA) {return -1;}
          return 0;
        })
        var sliceEnd = 0
        if(this.companiesToShow > companies.length) {
          this.isThereMoreCompaniesToShow = false
          sliceEnd = companies.length
        }
        else {
          this.isThereMoreCompaniesToShow = true
          sliceEnd = this.companiesToShow
        }
        return companies.slice(0,sliceEnd)
      },
      getWarehousedCustomers(){
        var companies = []
        var t = this
        companies.push({text: 'Avecor', value: 'avecor'})
        Object.keys(this.companies).forEach( key => {
          var c = t.companies[key]
          if(c.customerProductsWarehoused) companies.push({text: c.companyName, value: c.id})
        })
        return companies
      },
      allAccess(){
        let uid = this.user.uid
        //uid = 'b1AZld8HbadYgOOjIL1qVEKxyhh1'
        let access = this.staff[uid] !== undefined && (this.staff[uid].isAdmin || this.staff[uid].role == 'office' || this.staff[uid].role == 'warehouse') ? true : false
        //console.log({access})
        return access
      },
      
      getAllProducts(){
        var selectedProducts = []
        const keys = Object.keys(this.productsData)
        if (keys.length == 0) return []
        for (const key of keys) {
          var p = this.productsData[key]
          if (this.productsSearchInDrawer !== ""){
            var productTextsToSearch = ""
            if(p.name) productTextsToSearch += p.name
            if(p.nameWholesale) productTextsToSearch += p.nameWholesale
            if(p.nameEnglish) productTextsToSearch += p.nameEnglish
            if(p.id) productTextsToSearch += p.id
            if(p.wholesaleCompany) productTextsToSearch += p.wholesaleCompany
            if(p.productVariationSkus) productTextsToSearch += p.productVariationSkus
            if(productTextsToSearch.toLowerCase().includes(this.productsSearchInDrawer.toLowerCase())) selectedProducts.push(p)
          }
          else {
            selectedProducts.push(p)
          }
        }
        var sortedProducts = selectedProducts.sort((a,b)=>{
          var nameA=a.name.toLowerCase().trim(), nameB=b.name.toLowerCase().trim();
          if (nameA > nameB) {
            return 1;
          }
          if (nameB > nameA) {
            return -1;
          }
          return 0;
        })
        var sliceEnd = 0
        if(this.productsToShow > sortedProducts.length) {
          this.isThereMoreProductsToShow = false
          sliceEnd = sortedProducts.length
        }
        else {
          this.isThereMoreProductsToShow = true
          sliceEnd = this.productsToShow
        }
        return sortedProducts.slice(0,sliceEnd)
      },
      getWarehouseProducts(){
        var t = this
        var products = this.products
        var selectedProducts = []
        var newProducts = []
        var amountOfStockProducts = 0
        this.totalStockInWarehouse = 0
        this.totalStockInAvecorWarehouse = 0
        this.totalStockValueInAvecorWarehouse = 0
        this.totalStockInPrintShopWarehouse = 0
        this.totalStockValueInPrintShopWarehouse = 0

        this.totalStockInWarehouseNEW = 0
        this.totalStockInAvecorWarehouseNEW = 0
        this.totalStockValueInAvecorWarehouseNEW = 0
        this.totalStockInPrintShopWarehouseNEW = 0
        this.totalStockValueInPrintShopWarehouseNEW = 0
        
        var ast = 0
        var asv = 0

        const keys = Object.keys(this.productsData)
        
        if (keys.length == 0) return []
        let psUnderAvecorStockNotifyLevel = []
        let pvsUnderAvecorStockNotifyLevel = []
        for (const key of keys) {
          var p = this.productsData[key]
          var productWarehoused = false
          var productCampaigned = false
          
          // CALCULATE NEW STOCK NUMBERS AND VALUES HERE
          Object.keys(p.productVariations).forEach(pvId => {
            var pv = p.productVariations[pvId]
            var variationWarehoused = false
            var variationCampaigned = false

            // CALCULATE IF AVAILABLE LOWER THAN NOTIFICATION LEVEL
            var selectedWarehouse = this.selectedWarehouse
            var reserved = this.reserved
            var a = reserved[selectedWarehouse] && reserved[selectedWarehouse][p.id] && reserved[selectedWarehouse][p.id].variations && reserved[selectedWarehouse][p.id].variations[pvId] && reserved[selectedWarehouse][p.id].variations[pvId].total ? p.productVariations[pvId].avecorStock - reserved[selectedWarehouse][p.id].variations[pvId].total : p.productVariations[pvId].avecorStock
            var n = p.productVariations[pvId].avecorStockNotifyLevel ? p.productVariations[pvId].avecorStockNotifyLevel : 0
            if(Number(a) < Number(n) && pv.warehoused) {
              /* if(p.id === 'sNs6RnJtlXzvKSq42Yj8'){
                console.log({a,n,warehoused:pv.warehoused})
              } */
              psUnderAvecorStockNotifyLevel.push(p.id)
              pvsUnderAvecorStockNotifyLevel.push(pvId)
            }

            

            if(this.selectedWarehouse === 'avecor'){
              pv.warehoused ? productWarehoused = true : ''
              pv.campaigned ? productCampaigned = true : ''
              pv.warehoused ? variationWarehoused = true : false
              pv.campaigned ? variationCampaigned = true : false
            }
            else {
              pv.customersWarehoused && pv.customersWarehoused[this.selectedWarehouse] && pv.customersWarehoused[this.selectedWarehouse].warehoused ? productWarehoused = true : ''
              pv.customersWarehoused && pv.customersWarehoused[this.selectedWarehouse] && pv.customersWarehoused[this.selectedWarehouse].warehoused ? variationWarehoused = true : false
            }
            if(variationWarehoused){
              var avecorStock = 0
              var printShopStock = 0
              if(this.selectedWarehouse === 'avecor') {
                avecorStock = pv.avecorStock
                printShopStock = pv.printShopStock
              }
              else {
                //console.log(pv.customersWarehoused)
                avecorStock = pv.customersWarehoused[this.selectedWarehouse].avecorStock
                printShopStock = pv.customersWarehoused[this.selectedWarehouse].printShopStock
              }

              avecorStock = avecorStock && !isNaN(Number(avecorStock)) ? Number(avecorStock) : 0
              //printShopStock = printShopStock && !isNaN(Number(printShopStock)) ? Number(printShopStock) : 0
              
              //var printShopUnitPrice = pv.unitPurchasePrice && !isNaN(Number(pv.unitPurchasePrice)) ? Number(pv.unitPurchasePrice) : 0

              //this.totalStockInWarehouseNEW += avecorStock
              //this.totalStockInWarehouseNEW += printShopStock
              
              //this.totalStockInPrintShopWarehouseNEW += printShopStock
              //this.totalStockValueInPrintShopWarehouseNEW += printShopStock * printShopUnitPrice
              if(!isNaN(Number(avecorStock)) && avecorStock > 0) {
                ast += Number(avecorStock)
                var v = isNaN(parseFloat(pv.unitPurchasePrice)) ? 0 : avecorStock * parseFloat(pv.unitPurchasePrice)
                asv += v
              }
              //var avecorUnitPrice = pv.unitPurchasePrice && !isNaN(Number(pv.unitPurchasePrice)) ? Number(pv.unitPurchasePrice) : 0
              //this.totalStockInAvecorWarehouseNEW += avecorStock
              //this.totalStockValueInAvecorWarehouseNEW += avecorStock * avecorUnitPrice
            }
          })
          if((this.selectedWarehouseTab === 'warehouse' && productWarehoused) || (this.selectedWarehouseTab === 'campaignProducts' && productCampaigned)){
            amountOfStockProducts++
            if (this.productsSearch !== ""){
              var productTextsToSearch = ""
              if(p.nameWholesale) productTextsToSearch += p.nameWholesale
              if(p.nameEnglish) productTextsToSearch += p.nameEnglish
              if(p.name) productTextsToSearch += p.name
              if(p.id) productTextsToSearch += p.id
              if(p.wholesaleCompany) productTextsToSearch += p.wholesaleCompany
              if(p.wholesaleSku) productTextsToSearch += p.wholesaleSku
              if(p.productVariationSkus) productTextsToSearch += p.productVariationSkus
              if(p.warehouseInformation) productTextsToSearch += p.warehouseInformation
              Object.keys(p.productVariations).forEach(pvId => {
                if(p.productVariations[pvId].avecorSku) productTextsToSearch += p.productVariations[pvId].avecorSku
              })
              if(p.productVariationWholesaleSkus) productTextsToSearch += p.productVariationWholesaleSkus
              if(productTextsToSearch.toLowerCase().includes(this.productsSearch.toLowerCase())) selectedProducts.push(p)
            }
            else {
              if(this.showOnlyUnderAvecorStockNotifyLevel && psUnderAvecorStockNotifyLevel.includes(p.id)) selectedProducts.push(p)
              else if(!this.showOnlyUnderAvecorStockNotifyLevel) selectedProducts.push(p)
            }
          }
        }
        this.amountOfStockProducts = amountOfStockProducts
        var sortedProducts = selectedProducts.sort((a,b)=>{
          var nameA=a.name.toLowerCase().trim(), nameB=b.name.toLowerCase().trim();
          if (nameA > nameB) {
            return 1;
          }
          if (nameB > nameA) {
            return -1;
          }
          return 0;
        })
        //console.log(sortedProducts)
        this.pvsUnderAvecorStockNotifyLevel = pvsUnderAvecorStockNotifyLevel
        asv = asv.toFixed(2)
        this.totalStockInAvecorWarehouseNEW = this.numberWithSpaces(ast)
        this.totalStockValueInAvecorWarehouseNEW = this.numberWithSpaces(asv)


        return sortedProducts
        /* var sliceEnd = 0
        if(this.productsToShow > sortedProducts.length) {
          this.isThereMoreProductsToShow = false
          sliceEnd = sortedProducts.length
        }
        else {
          this.isThereMoreProductsToShow = true
          sliceEnd = this.productsToShow
        }
        return sortedProducts.slice(0,sliceEnd) */
      },
      ...mapFields({
        settings:"settings",
        reserved:"reserved",
        products:'product.products',
        companies:'company.companies',
        productVariations:'productVariation.productVariations',
        orders:'order.orders',
        orderedProducts:'orderedProduct.orderedProducts',
        wholesaleCompanies:'wholesaleCompany.wholesaleCompanies',
        printShops:'printShop.printShops',
        isSales:'settings.isSales',
        printFormatsObject:"settings.printFormatsObject",
        selectedProductId:"views.stock.selectedProduct.productId",
        selectedWholesaleCompanyId:"views.stock.selectedWholesaleCompany.wholesaleCompanyId",
        selectedOrderOrderId:"views.stock.selectedOrder.orderId",
        user:"user",
        staff:"staff.staff",
        device:"device",
        newBatchModalVisible:"modals.batches.new.visible",
        newBatchModalProductId:"modals.batches.new.productId",
        newBatchModalProductVariationId:"modals.batches.new.productVariationId",
      })
    },

    watch: {
      isSales:{
        handler(val){
          if(val) this.showBatchInformation = false
        },
      },
      wholesaleCompanies:{
        handler(val){
          this.generateProductsData()
        },
        deep: true
      },
      productVariations: {
        handler(val){
          //console.log("WATCH TRIGGRED FOR PVs")
          this.generateProductsData()
        },
        deep: true
      },
      products: {
        handler(val){
          //console.log("WATCH TRIGGRED FOR PVs")
          this.generateProductsData()
        },
        deep: true
      },
      orderedProducts: {
        handler(val){
          //console.log("WATCH TRIGGRED FOR PVs")
          this.calculateReserved()
          this.calculateIncompletes()
        },
        deep: true
      },
      orders: {
        handler(val){
          //console.log("WATCH TRIGGRED FOR PVs")
          this.calculateReserved()
          this.calculateIncompletes()
        },
        deep: true
      },
      /* products: {
        handler(val){
          this.generateProductsData()
        },
        deep: true
      } */
    },
    methods: {
      numberWithSpaces(x) {
        var parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        return parts.join(".");
      },
      saveReserved(){
        var reserved = this.reserved
        this.getWarehouseProducts.forEach(p => {
          Object.keys(p.productVariations).forEach(pvId => {
            //p.productVariations[pvId]
            if(reserved['avecor'] && reserved['avecor'][p.id] && reserved['avecor'][p.id].variations && reserved['avecor'][p.id].variations[pvId] && reserved['avecor'][p.id].variations[pvId].total){
              var reservedAvecor = reserved['avecor'][p.id].variations[pvId].total
              console.log(p.id,pvId,reservedAvecor)
              this.$store.dispatch('productVariation/set', {
                id:pvId,
                reservedAvecor
              })  
              
            }
          })
        })
      },
      getStylesForAvailableField(p, pvId){
        var selectedWarehouse = this.selectedWarehouse
        var reserved = this.reserved

        var a = reserved[selectedWarehouse] && reserved[selectedWarehouse][p.id] && reserved[selectedWarehouse][p.id].variations && reserved[selectedWarehouse][p.id].variations[pvId] && reserved[selectedWarehouse][p.id].variations[pvId].total ? p.productVariations[pvId].avecorStock - reserved[selectedWarehouse][p.id].variations[pvId].total : p.productVariations[pvId].avecorStock
        var n = p.productVariations[pvId].avecorStockNotifyLevel ? p.productVariations[pvId].avecorStockNotifyLevel : 0
        
        if(isNaN(Number(a)) || isNaN(Number(a))) 'background:#eee !important;padding-left:20px; margin-right:20px;'
        //if(pvId === "1c3xuj80Rny4JlFz4MpU") console.log({a,n})
        if( Number(a) < Number(n)) {
          return 'background:#FFCDD2 !important;padding-left:20px; margin-right:20px;'
        }
        else {
          return 'background:#eee !important;padding-left:20px; margin-right:20px;'
        }
        
      },
      updateStockBasedOnAvailable(p, pId, selectedWarehouse, pvId, value){
        var reserved = this.reserved
        var currentValue = reserved[selectedWarehouse] && reserved[selectedWarehouse][pId] && reserved[selectedWarehouse][pId].variations && reserved[selectedWarehouse][pId].variations[pvId] && reserved[selectedWarehouse][pId].variations[pvId].total ? p.productVariations[pvId].avecorStock - reserved[selectedWarehouse][pId].variations[pvId].total : p.productVariations[pvId].avecorStock
        if(isNaN(Number(currentValue))){
          alert("Päivitys EI onnistunut. Tuotten varauksen määrässä virhe. Laita viestiä Tomille. Lisää viestiin tuotenimi.")
          return
        }
        if(isNaN(Number(value))){
          alert("Vain luvut sallittuja.")
          this.available_product_ref_counter = this.available_product_ref_counter + 1
          return
        }
        if(value !== '' && !(/^-?\d+$/).test(value)) {
          alert("Syötä täysiluku ilman pisteitä tai pilkkuja")
          var clone = JSON.parse(JSON.stringify(this.keysObj))
          if(this.keysObj[pvId]) clone[pvId] += 1 
          else clone[pvId] = 1
          this.keysObj = clone
          return
        } 
        value = Number(value)
        currentValue = Number(currentValue)
        var change =  value - currentValue
        var currentAvecorStock = p.productVariations[pvId].avecorStock
        if(isNaN(Number(currentAvecorStock))){
          alert("Varaston saldo ei ole luku.")
          return
        }
        currentAvecorStock = Number(currentAvecorStock)
        var newStock = currentAvecorStock + change
        
        var newStatusUser = this.user.uid
        this.logStockUpdateProductChange(pId,pvId,'','',newStatusUser,Number(currentAvecorStock),newStock,change,"updatedAvailableStockField")
        var stockNotifyLevel = p.productVariations[pvId].avecorStockNotifyLevel
        if(value > stockNotifyLevel){
          this.$store.dispatch('productVariation/set', {
            id:pvId,
            avecorStock:newStock,
            sendAvecorStockNotifyEmail:true
          })  
        }
        else {
          this.$store.dispatch('productVariation/set', {
            id:pvId,
            avecorStock:newStock,
            sendAvecorStockNotifyEmail:true
          })
        }
      },
      getSortedReservations(r){
        console.log(r)
        var clone = JSON.parse(JSON.stringify(r))
        var sorted = clone.sort(function(a,b){
          var a = new Date(a.created_at.seconds*1000)
          var b = new Date(b.created_at.seconds*1000)
          return  b -a
        });
        console.log(sorted)
        return sorted
      },
      initiateLogs(){
        var t = this
        db.collection("productVariationChangeLogs")
        .onSnapshot(function(querySnapshot) {
            t.logsMap = {}
            querySnapshot.forEach(function(doc) {
                t.logsMap[doc.id] = {...doc.data(),id:doc.id}
            });
        })
      },
      calculateIncompletes(){
        var t = this
        var incompletes = {
          avecor:{}
        }
        var orderedProducts = this.orderedProducts
        Object.keys(orderedProducts).forEach(opId => {
          var op = orderedProducts[opId]
          var pId = op.productId
          var pvId = op.productVariationId
          var os = op.orderStatus
          incompletes.avecor[pId] ? '' : incompletes.avecor[pId] = {incompletes:0, variations:{}}
          incompletes.avecor[pId].variations[pvId] ? '' : incompletes.avecor[pId].variations[pvId] = 0
          
          //console.log(Number.isInteger(parseInt(op.quantity)))
          if(op.quantity && Number.isInteger(parseInt(op.quantity)) && os && os !== 'productsShipped' && os !== 'orderCreated' && os !== 'orderCreatedToPrintShop' ){
              //console.log(op.quantity)
              incompletes.avecor[pId].incompletes = incompletes.avecor[pId].incompletes + parseInt(op.quantity)
              incompletes.avecor[pId].variations[pvId] = incompletes.avecor[pId].variations[pvId] + parseInt(op.quantity)
              //console.log(incompletes.avecor[pId].variations[pvId])
          }
          // Varauks
          /* if(op.quantity && Number.isInteger(parseInt(op.quantity)) && os && os !== 'productsShipped' && os !== 'orderCreated' && os !== 'orderCreatedToPrintShop' ){
              //console.log(op.quantity)
              incompletes.avecor[pId].incompletes = incompletes.avecor[pId].incompletes + parseInt(op.quantity)
              incompletes.avecor[pId].variations[pvId] = incompletes.avecor[pId].variations[pvId] + parseInt(op.quantity)
              //console.log(incompletes.avecor[pId].variations[pvId])
          } */
          
          
        })
        this.incompletes = incompletes
      },
      copyToClipboard (text) {
        this.$clipboard(text)
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Kopioitu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      },
      updateWarehouseCustomerStock(shopifyCustomerIdTag,sku,newAvecorStock){
        var self = this
        firebase.auth().currentUser.getIdToken().then(function(token){
            axios.defaults.headers.common['Authorization'] = "Bearer " +token;
            var url = self.settings.dev ? 'http://api-test.avecor.fi:5000/avecor-709ff/us-central1/shopifyUpdateStock': 'https://us-central1-avecor-709ff.cloudfunctions.net/shopifyUpdateStock'
            axios.post(
                url,
                {
                    shopifyCustomerIdTag,
                    sku,
                    newAvecorStock
                }
            )
            .then(function(response) {
                self.$store.dispatch('showSnack', { snack:true, snackTimeout:5000, snackText:"Saldo päivitetty asiakkaan shopify kauppaan.", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
            })
            .catch(function(error) {
              console.log(error.message)
              var message = (error && error.response && error.response.data && error.response.data.message) ? error.response.data.message : error;

              self.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:message, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
                //console.log(error);
            });
        })
      },
      checkForShopifyProduct(sku){
        var self = this
        return new Promise(async function(resolve, reject) {
          try{
            
            var token = await firebase.auth().currentUser.getIdToken()
            axios.defaults.headers.common.Authorization = 'Bearer ' + token;
            var url = self.settings.dev ? 'http://api-test.avecor.fi:5000/avecor-709ff/us-central1/checkForShopifyProduct': 'https://us-central1-avecor-709ff.cloudfunctions.net/checkForShopifyProduct'
            await axios.post(
                url,
                {
                    sku,
                }
            )
            resolve(true)
          }
          catch(e){
            console.log("TESTING")
            reject(e)
          }
        })
          
      },
      toggleProductInCustomerShopify(shopifyCustomerIdTag,selectedWarehouse, sku,pvId, warehoused,newAvecorStock){
        var self = this
        var removeCompanyTagFromProduct = true
        if(warehoused) removeCompanyTagFromProduct = false
        
        var pv = this.productVariations[pvId]
        var pId = pv.productId

        Object.keys(this.productVariations).forEach(npvId => {
          var npv = this.productVariations[npvId]
          if(pId === npv.productId && npvId !== pvId) {
            if(npv.customersWarehoused && npv.customersWarehoused[selectedWarehouse] && npv.customersWarehoused[selectedWarehouse].warehoused) removeCompanyTagFromProduct = false
          }
        })
        firebase.auth().currentUser.getIdToken().then(function(token){
            axios.defaults.headers.common['Authorization'] = "Bearer " +token;
            var url = self.settings.dev ? 'http://api-test.avecor.fi:5000/avecor-709ff/us-central1/toggleProductInCustomerShopify': 'https://us-central1-avecor-709ff.cloudfunctions.net/toggleProductInCustomerShopify'
            axios.post(
                url,
                {
                    shopifyCustomerIdTag,
                    sku,
                    warehoused,
                    removeCompanyTagFromProduct,
                    newAvecorStock
                }
            )
            .then(function(response) {
              console.log(response.data.message)
              var text = warehoused ? "Tuote lisätty asiakkaan shopify-kauppaan." : "Tuote poistettu asiakkaan shopify-kaupasta."

              self.$store.dispatch('showSnack', { snack:true, snackTimeout:5000, snackText:text, snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
            })
            .catch(function(error) {
              console.log(error.message)
              var message = (error && error.response && error.response.data && error.response.data.message) ? error.response.data.message : error;

              self.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:message, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
                //console.log(error);
            });
        })
      },
      saveCustomerWarehouseUpdate(selectedWarehouse,pvId,field,value){
        
        if (field === "avecorStock" || field === "printShopStock") {
          value = value.replace(",", ".")
          if(!value ||  !(/^-?\d+$/).test(value)) {
            var clone = JSON.parse(JSON.stringify(this.keysObj))
            if(this.keysObj[pvId]) clone[pvId] += 1 
            else clone[pvId] = 1
            this.keysObj = clone
            alert("Syötä täysiluku ilman pisteitä tai pilkkuja")     
            return       
          } 
          else {
            if(this.productVariations[pvId] && this.productVariations[pvId].customersWarehoused && this.productVariations[pvId].customersWarehoused[selectedWarehouse]){
              this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Päivitetään asiakkaan saldoa Shopifyhin...", snackButtonText: "", errorType:"", snackColor:'deep-blue',right:true,top:true})
              var customersWarehoused = this.productVariations[pvId].customersWarehoused
              customersWarehoused[selectedWarehouse][field] = Number(value)
              this.$store.dispatch('productVariation/set', {
                id:pvId,
                customersWarehoused
              })
              //.then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
              if(field === "avecorStock" && this.companies[selectedWarehouse] && this.companies[selectedWarehouse].shopifyCustomerIdTag){
                var pId = this.productVariations[pvId].productId
                if(this.productVariations[pvId] && this.productVariations[pvId].productId && this.productsData[pId].productVariations[pvId] && this.productsData[pId].productVariations[pvId].avecorSku){
                  console.log(this.companies[selectedWarehouse].shopifyCustomerIdTag, this.productsData[pId].productVariations[pvId].avecorSku, value)
                  this.updateWarehouseCustomerStock(this.companies[selectedWarehouse].shopifyCustomerIdTag,this.productsData[pId].productVariations[pvId].avecorSku,value)
                }
                else{
                  this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Avecor tuotekoodia ei määritelty, jotta päivitys shopifyn onnistuisi.", snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
                }
              }
              else {
                this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Shopify tunnusta ei ole määritelty.", snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
              }
            }
          }
        }
      },
      editBatch(value,field,pvId, batchId){
        if(pvId === undefined || pvId === "") return
        if(batchId === undefined || batchId === "") return
        if(field === undefined || field === "") return
        console.log({value,field,pvId,batchId})
        
        var batches = this.productVariations[pvId].batches //this.$store.getters.productVariations[pvId].batches
        
        if(field === "quantity"){
          var newBatchQuantity = Number(value)
          if (!newBatchQuantity || isNaN(newBatchQuantity)) {
            var clone = JSON.parse(JSON.stringify(this.keysObj))
            if(this.keysObj[pvId]) clone[pvId] += 1 
            else clone[pvId] = 1
            this.keysObj = clone
            alert("Syötä numeerinen määrä.")
          }
          else {
            //console.log(batches[batchId].reservations.total)
            var reservations = batches[batchId].reservations.total !== undefined ? batches[batchId].reservations.total : 0
            var currentBatchQuantity = batches[batchId].quantity
            if(newBatchQuantity - reservations >= 0 ){
              batches[batchId].quantity = newBatchQuantity
              this.$store.dispatch('productVariation/set', {
                id:pvId,
                batches
              }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
            }
            else {
              var clone = JSON.parse(JSON.stringify(this.keysObj))
              if(this.keysObj[pvId]) clone[pvId] += 1 
              else clone[pvId] = 1
              this.keysObj = clone
              alert("Erästä on varattu suurempi kuin syötetty määrän. Uuden määrän oltava suurempi kun tällä hetkellä varattu.")
            }
          }
        }
        else if(field === "unitPrice"){
          var unitPrice = parseFloat(value)
          if (!unitPrice || isNaN(unitPrice)) {
            alert("Syötä numeerinen määrä.")
            this.productVariations[pvId].batches = batches 
          }
          else {
            batches[batchId].unitPrice = unitPrice
            this.$store.dispatch('productVariation/set', {
              id:pvId,
              batches
            }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
          }
        }
        else if(field === "quantityArrived" || field === "quantityArrived2" || field === "quantityArrived3"){
          var newArrivedQuantity = Number(value)
          if (!newArrivedQuantity || isNaN(newArrivedQuantity)) {
            this.batchesKey++
            var clone = JSON.parse(JSON.stringify(this.keysObj))
            if(this.keysObj[pvId]) clone[pvId] += 1 
            else clone[pvId] = 1
            this.keysObj = clone
            alert("Syötä numeerinen määrä.")
          }
          else{
            batches[batchId][field] = newArrivedQuantity
            this.$store.dispatch('productVariation/set', {
              id:pvId,
              batches
            }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
          }
        }
        else if (field === "status"){
          var pv =  this.$store.getters.productVariations[pvId]
          var currentLocation = this.$store.getters.productVariations[pvId].batches[batchId].stockLocation
          var quantity = this.$store.getters.productVariations[pvId].batches[batchId].quantity
          quantity = Number(quantity)
          //var currentAvecorStock = Number(pv.avecorStock)
          //var currentPrintShopStock = Number(pv.printShopStock)
          var currentBatchStatus = batches[batchId].status
          batches[batchId].status = value
          var currentBatchQuantity = batches[batchId].quantity
          var currentAvecorStock = 0
          if(this.productVariations[pvId].avecorStock !== undefined) currentAvecorStock = Number(this.productVariations[pvId].avecorStock)
          var newStatusUser = this.user.uid
          var newValue = currentAvecorStock
          var change = 0
          if(value === 'batchShelfed' && currentBatchStatus !== 'batchShelfed'){
            var newValue = currentAvecorStock + currentBatchQuantity
            change = Number(currentBatchQuantity)
            this.logStockUpdateProductChange(pv.productId,pvId,'','',newStatusUser,Number(currentAvecorStock),newValue,change,"batchShelfed")
          }
          
          else if(value !== 'batchShelfed' && currentBatchStatus === 'batchShelfed'){
            var newValue = currentAvecorStock - currentBatchQuantity
            change = 0-Number(currentBatchQuantity)
            this.logStockUpdateProductChange(pv.productId,pvId,'','',newStatusUser,Number(currentAvecorStock),newValue,change,"batchUnshelfed")
          }

          if(value === "batchArrivedToWarehouse" || value === "batchShelfed" || value === "batchPartiallyShelfed"){
            console.log(value, currentBatchStatus)
            batches[batchId].arrivalDate = new Date().toISOString().substr(0, 10)
            this.$store.dispatch('productVariation/set', {
              id:pvId,
              sendAvecorStockNotifyEmail:true,
              avecorStock:newValue,
              batches
            }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
          }
          else {
            batches[batchId].arrivalDate = ""
            this.$store.dispatch('productVariation/set', {
              id:pvId,
              avecorStock:newValue,
              batches
            }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
          }
        }
        else {
          batches[batchId][field] = value
          this.$store.dispatch('productVariation/set', {
            id:pvId,
            batches
          }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        }
      },
      showFieldsForBatchPart(batch, number){
        
        if(number === 2){
          
          if(batch.quantityArrived){
            //if(batch.id === '28tb96cc4h7zvn71qx') console.log("BATCH HERE")
            if(!isNaN(Number(batch.quantityArrived))){
              if(Number(batch.quantityArrived) != batch.quantity) return true
            }
          } 
        }
        else if(number === 3){
          if(batch.quantityArrived && batch.quantityArrived2){
            if(!isNaN(Number(batch.quantityArrived)) && !isNaN(Number(batch.quantityArrived2))){
              if(Number(batch.quantityArrived) + Number(batch.quantityArrived2) != batch.quantity) return true
            }
          } 
        }
        return false
      },
      saveCompanyDetails(id,field,value){
        //console.log(id,field,value)
        this.$store.dispatch('company/set', {
          id,
          [field]:value
        })
      },
      async saveCampaignedStatus(selectedWarehouse,pvId,campaigned){
        if(selectedWarehouse === 'avecor'){
          this.$store.dispatch('productVariation/set', {
            id:pvId,
            campaigned
          })
        }
      },
      saveWarehouseStatusForProduct(warehouse,pId,warehoused){
        var p = this.productsData[pId]
        if (confirm('Haluatko varmasti poistaat tuotteen varastosta?')) {
          Object.keys(p.productVariations).forEach(pvId => {
            this.$store.dispatch('productVariation/set', {
              id:pvId,
              warehoused
            })
          })
          this.$store.dispatch('product/set', {
            id:pId,
            warehoused
          })
          .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        }
      },
      async saveWarehousedStatus(selectedWarehouse,pvId,warehoused){
        if(selectedWarehouse === 'avecor'){
          this.$store.dispatch('productVariation/set', {
            id:pvId,
            warehoused
          })
        }
        else {
          var sku = this.createVariationAvecorSku(pvId)
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Päivitetään tietoja shopifyhin, odota hetki...", snackButtonText: "", errorType:"", snackColor:'deep-blue',right:true,top:true})
          if(!sku){
            this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Tuotteelle ei ole määritelty tuotekoodia.", snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
            return
          }
          if(!this.companies[selectedWarehouse].shopifyCustomerIdTag){
            this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Shopifyn tagia ei määritelty yritykselle.", snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
            return
          }
          try{
            var found = await this.checkForShopifyProduct(sku)
            console.log(found)
            var customersWarehoused = null
            //console.log(this.productVariations[pvId])
            if(!this.productVariations[pvId].customersWarehoused){
              customersWarehoused = {
                [selectedWarehouse]:{
                  warehoused,
                  avecorStock:0,
                  printShopStock:0
                }
              }
            }
            else if(!this.productVariations[pvId].customersWarehoused[selectedWarehouse]){
              customersWarehoused = this.productVariations[pvId].customersWarehoused
              customersWarehoused[selectedWarehouse] = {
                warehoused,
                avecorStock:0,
                printShopStock:0
              }
            }
            else if (this.productVariations[pvId].customersWarehoused[selectedWarehouse]){
              customersWarehoused = this.productVariations[pvId].customersWarehoused
              customersWarehoused[selectedWarehouse].warehoused = warehoused
            }
            if(customersWarehoused){
              this.$store.dispatch('productVariation/set', {
                id:pvId,
                customersWarehoused
              })
            }
            // UPDATE STATUS
            if(this.companies[selectedWarehouse] && this.companies[selectedWarehouse].shopifyCustomerIdTag){
              if(this.productVariations[pvId] && this.products[this.productVariations[pvId].productId]){
                var sku = this.createVariationAvecorSku(pvId)
                //this.products[this.productVariations[pvId].productId].avecorSku
                var avecorStock = 0
                if(this.productVariations[pvId].customersWarehoused && this.productVariations[pvId].customersWarehoused[selectedWarehouse]) {
                  avecorStock = this.productVariations[pvId].customersWarehoused[selectedWarehouse].avecorStock
                }
                
                this.toggleProductInCustomerShopify(this.companies[selectedWarehouse].shopifyCustomerIdTag, selectedWarehouse, sku, pvId, warehoused,avecorStock)
              }
            }
          }
          catch(e){
            this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Tuotetta ei löytynyt Shopifysta", snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
          }
        }
      },
      getTotalStock(batches, stockLocation){
        return 0
      },
      getOrderableInBatch(batch){
        return batch.quantity - (batch.reservations !== undefined && batch.reservations.total !== undefined ? batch.reservations.total : 0)
      },
      
      getStockInBatch(batch){
        return batch.quantity - (batch.shipped !== undefined && batch.shipped.total !== undefined ? batch.shipped.total : 0)
      },
      exportStockTable(){
        var data = []
        var pv = ''
        var products = this.getWarehouseProducts
        var ast = 0
        var pst = 0
        for (const p of products) {
          for (const pvId of Object.keys(p.productVariations)){
            var pv = p.productVariations[pvId]
            if(!pv.warehoused) continue
            var pss = pv.printShopStock && pv.printShopStock > 0 ? pv.printShopStock : 0
            var avs = pv.avecorStock && pv.avecorStock > 0 ? pv.avecorStock : 0
            var o = {
              tuote: p.name,
              variaation_nimi:pv.name,
              variaation_tuotekoodi:pv.avecorSku,
              avecor_saldo:avs,
              avecor_invis_saldo: '',
              merkkaamon_saldo:pss,
              sisaanostohinta:pv.unitSalesPrice,
              ostohinta:pv.unitPurchasePrice
            }
            if((pss > 0) || (avs > 0)) data.push(o)
            if(!isNaN(Number(pss)) && pss > 0) pst += Number(pss)
            if(!isNaN(Number(avs)) && avs > 0) ast += Number(avs)
          }
        }
        var ot = {
          tuote: "TOTAL",
          variaation_nimi:"",
          variaation_tuotekoodi:"",
          avecor_saldo:ast,
          avecor_invis_saldo: '',
          merkkaamon_saldo:pst,
          sisaanostohinta:"",
          ostohinta:""
        }
        data.push(ot)

        const options = { 
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          filename:'Avecor Varaston Saldotiedot', 
          //showTitle: true,
          //title:name +  'Kontaktitiedot',
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
        };
        
        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(data);
      },

      getUnallocated(batch,unallocatedId){

      },
      getSortedBatches(batches){
        var arrivingBatches = []
        var arrivedBatches = []
        
        Object.keys(batches).forEach(batchId => {
          if(this.showAllBatches) batches[batchId].status === "batchOrdered" || batches[batchId].status === "batchPartiallyShelfed" ? arrivingBatches.push({id:batchId,...batches[batchId]}) : ''
          //else batches[batchId].status === "batchOrdered" && this.getOrderableInBatch(batches[batchId]) > 0 ? arrivingBatches.push({id:batchId,...batches[batchId]}) : ''
          else batches[batchId].status === "batchOrdered" && this.getStockInBatch(batches[batchId]) > 0 ? arrivingBatches.push({id:batchId,...batches[batchId]}) : ''
        })
        
        Object.keys(batches).forEach(batchId => {
          if(this.showAllBatches) (batches[batchId].status === "batchArrivedToWarehouse" || batches[batchId].status === "batchShelfed") ? arrivedBatches.push({id:batchId,...batches[batchId]}) : ''
          //else batches[batchId].status === "batchArrivedToWarehouse" && this.getOrderableInBatch(batches[batchId]) > 0 ? arrivedBatches.push({id:batchId,...batches[batchId]}) : ''
          else {
            (batches[batchId].status === "batchArrivedToWarehouse" || batches[batchId].status === "batchShelfed") && this.getStockInBatch(batches[batchId]) > 0 ? arrivedBatches.push({id:batchId,...batches[batchId]}) : ''
          }
        })
        //console.log(arrivedBatches)
        
        arrivedBatches.sort(function(a,b){
          return new Date(a.arrivalDate) - new Date(b.arrivalDate)
        });
        //console.log(arrivedBatches)
        arrivingBatches.sort(function(a,b){
          return new Date(a.estimatedArrivalDate) - new Date(b.estimatedArrivalDate)
        });
        var unallocatedExists = false
        var batchesReturned = [...arrivedBatches, ...arrivingBatches]
        //console.log(batchesReturned)
        /* var unallocatedBatch = {id:"unallocated", reservations:{avecor:{total:0},printShop:{total:0}},shipped:{avecor:{total:0},printShop:{total:0}}}
        if(batches.unallocatedAvecor !== undefined && batches.unallocatedAvecor.total !== undefined && batches.unallocatedAvecor.total !== 0){
          //console.log(batches.unallocated)
          unallocatedExists = true
          unallocatedBatch.reservations === undefined ? unallocatedBatch.reservations = {} : ''
          unallocatedBatch.reservations.avecor === undefined ? unallocatedBatch.reservations.avecor = {} : ''
          unallocatedBatch.reservations.avecor.total = batches.unallocatedAvecor.total
          
        }
        if(batches.unallocatedPrintShop !== undefined && batches.unallocatedPrintShop.total !== undefined && batches.unallocatedPrintShop.total !== 0){
          unallocatedExists = true
          unallocatedBatch.reservations === undefined ? unallocatedBatch.reservations = {} : ''
          unallocatedBatch.reservations.printShop === undefined ? unallocatedBatch.reservations.printShop = {} : ''
          unallocatedBatch.reservations.printShop.total = batches.unallocatedPrintShop.total
        }
        if(unallocatedExists){
          batchesReturned = {unallocatedBatch, ...batchesReturned}
        } */
        //console.log(batchesReturned)
        return batchesReturned
      },
      formGmailLink(email){
        return "https://mail.google.com/mail/?view=cm&fs=1&to="+email+"&su=Uusi erätilaus&body=Hei,\nTilaisimme uuden erän"//&bcc=someone.else@example.com"
      },
      saveProductVariationUpdate(pvId,field,value){
        if (field === "avecorStock" || field === "printShopStock" || field === "avecorStockNotifyLevel" || field === "printShopStockNotifyLevel") {
          value = value.replace(",", ".")
          if(isNaN(Number(value))){
            alert("Vain luvut sallittuja.")
            this.available_product_ref_counter = this.available_product_ref_counter + 1
            return
          }
          console.log(value)
          if(value !== '' && !(/^-?\d+$/).test(value)) {
            alert("Syötä täysiluku ilman pisteitä tai pilkkuja")
            var clone = JSON.parse(JSON.stringify(this.keysObj))
            if(this.keysObj[pvId]) clone[pvId] += 1 
            else clone[pvId] = 1
            this.keysObj = clone
            return
          } 
          else {
            if(field ==="avecorStock"){
              var currentAvecorStock = this.productVariations[pvId].avecorStock == undefined ?  0 : this.productVariations[pvId].avecorStock
              var currentAvecorStock = this.productVariations[pvId].avecorStock == undefined ?  0 : this.productVariations[pvId].avecorStock
              this.$store.dispatch('productVariation/set', {
                id:pvId,
                sendAvecorStockNotifyEmail:true,
                [field]:value
              })
              .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))  
              var pId = this.productVariations[pvId] ? this.productVariations[pvId].productId : ''
              var newStatusUser = this.user.uid
              var change = Number(value)-Number(currentAvecorStock)
              this.logStockUpdateProductChange(pId,pvId,'','',newStatusUser,Number(currentAvecorStock),value,change,"updatedStockField")
            }
            else if (field === 'avecorStockNotifyLevel'){
              var sendAvecorStockNotifyEmail = true
              if(value === '') sendAvecorStockNotifyEmail = false
              this.$store.dispatch('productVariation/set', {
                id:pvId,
                sendAvecorStockNotifyEmail,
                [field]:value
              })
              .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
            }
            else{
              this.$store.dispatch('productVariation/set', {
                id:pvId,
                [field]:value
              })
              .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
            }
          }
        }
        else {
          if (field === "officeMargin") value = value.replace(",", ".") 
          this.$store.dispatch('productVariation/set', {
            id:pvId,
            [field]:value
          })
          .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
          
        }
      },
      saveProductUpdate(pId,field,value){
        this.$store.dispatch('product/set', {
          id:pId,
          [field]:value
        })
        .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
      },
      saveCompanyUpdate(id,field,value){
        this.$store.dispatch('company/set', {
          id,
          [field]:value
        })
        .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
      },
      customFormatter(date) {
        if (date.seconds) {
          var myDate = new Date(date.seconds*1000);
          return dateFormat(myDate, "yyyy-mm-dd HH:MM")
        }
        else if (date !== undefined && date.seconds === undefined){
          return dateFormat(date, "yyyy-mm-dd HH:MM")
        }
        return ''
      },
      generateProductsData(){
        var productsData = {}
        var t = this
        t.numberOfExceededArrivalDates = 0
        t.numberOfWithin3DaysArrivalDates = 0
        /* if(this.createVariationName === undefined) console.log("HERE")
        console.log(this.createVariationName)
        return productsData */

        Object.keys(this.productVariations).forEach( key => {
          var pv = t.productVariations[key]
          if(t.products[pv.productId] === undefined) {console.log (); return}
          
          var p = t.products[pv.productId]
          productsData[pv.productId] === undefined ? productsData[pv.productId] = {} : ""
          Object.defineProperty(productsData, pv.productId, { configurable: false });
          productsData[pv.productId].productVariations === undefined ? productsData[pv.productId].productVariations = {} : ""
          p.warehouseInformation !== undefined ? productsData[pv.productId].warehouseInformation = p.warehouseInformation : ""
          t.products[pv.productId].productInformation !== undefined ? productsData[pv.productId].productInformation = t.products[pv.productId].productInformation : ""
          productsData[pv.productId].id = pv.productId
          productsData[pv.productId].created_at = t.products[pv.productId].created_at
          t.products[pv.productId].archived !== undefined ? productsData[pv.productId].archived = t.products[pv.productId].archived : productsData[pv.productId].archived = false
          t.products[pv.productId].warehoused !== undefined ? productsData[pv.productId].warehoused = t.products[pv.productId].warehoused : productsData[pv.productId].warehoused = false
          productsData[pv.productId].deliveryTime = t.products[pv.productId].deliveryTime
          productsData[pv.productId].isPrintProduct = t.products[pv.productId].isPrintProduct
          productsData[pv.productId].isDoubleSidePrintPossible = t.products[pv.productId].isDoubleSidePrintPossible
          productsData[pv.productId].name = t.products[pv.productId].name.fi
          productsData[pv.productId].nameWholesale = t.products[pv.productId].name.wholesale ? t.products[pv.productId].name.wholesale : ''
          productsData[pv.productId].nameEnglish = t.products[pv.productId].name.en ? t.products[pv.productId].name.en : ''
          
          productsData[pv.productId].officeComments = t.products[pv.productId].officeComments
          productsData[pv.productId].printFormats = ""
          productsData[pv.productId].selectedProductImageId = t.products[pv.productId].selectedProductImageId !== undefined ? t.products[pv.productId].selectedProductImageId : ""
          
          t.products[pv.productId].printFormats !== undefined ? t.products[pv.productId].printFormats.forEach(format => {
            t.printFormatsObject[format] !== undefined ? productsData[pv.productId].printFormats += t.printFormatsObject[format].fi : ""
          }) : ""
          
          if(t.products[pv.productId].wholesaleCompany !== undefined && t.wholesaleCompanies[t.products[pv.productId].wholesaleCompany] !== undefined && 
          t.wholesaleCompanies[t.products[pv.productId].wholesaleCompany].partnerContacts !== undefined){
            
            Object.keys(t.wholesaleCompanies[t.products[pv.productId].wholesaleCompany].partnerContacts).forEach(key =>{
              
              var contact = t.wholesaleCompanies[t.products[pv.productId].wholesaleCompany].partnerContacts[key]
              //contact.contactType === 'ordersContact' ? console.log("HERE") : ""
              contact.contactType === 'ordersContact' ? productsData[pv.productId].ordersContactEmail = contact.email : productsData[pv.productId].ordersContactEmail = ''
              contact.contactType === 'ordersContact' ? productsData[pv.productId].ordersContactPhone = contact.phone : productsData[pv.productId].ordersContactPhone = ''
            })
          }


          productsData[pv.productId].wholesaleCompanyId = t.wholesaleCompanies[t.products[pv.productId].wholesaleCompany] !== undefined ? t.wholesaleCompanies[t.products[pv.productId].wholesaleCompany].id : ""
          productsData[pv.productId].wholesaleCompany = t.wholesaleCompanies[t.products[pv.productId].wholesaleCompany] !== undefined ? t.wholesaleCompanies[t.products[pv.productId].wholesaleCompany].name : ""
          productsData[pv.productId].printShops = ""
          t.products[pv.productId].printShops !== undefined && Array.isArray(t.products[pv.productId].printShops) ? t.products[pv.productId].printShops.forEach(shop => {
            t.printShops[shop] !== undefined ? productsData[pv.productId].printShops += t.printShops[shop].name +", " : ""
            //console.log(productsData[pv.productId].printShops)
          }) : ""
          //productsData[pv.productId].printShops = typeof t.printShops[t.products[pv.productId].wholesaleCompany] !== "undefined" ? t.wholesaleCompanies[t.products[pv.productId].wholesaleCompany].name : ""
          var text = t.createVariationName(pv)
          var unitSalesPrice = 0
          var unitPurchasePrice = 0
          var isUnitSalesPriceFromPrices = false
          if(pv.unitSalesPrice !== undefined) unitSalesPrice = pv.unitSalesPrice
          if(pv.unitPurchasePrice !== undefined) unitPurchasePrice = pv.unitPurchasePrice
          // UNIT SALES PRICE FROM PRICES
          /* if(p.prices && p.prices.ranges[8]) {
            console.log(p)
          } */
          if(p.prices && p.prices.ranges[8]){
            var matchedProductPriceRange = t.getRange(p.prices.ranges,1)
            var noPrintOption = null
            p.prices.options.forEach((o,i) => {
              if(o.printFormat === 'no_print' && o.level1.includes("Varasto")){
                noPrintOption = o
              }
            })
            if(!noPrintOption){
              p.prices.options.forEach((o,i) => {
                if(o.printFormat === 'no_print'){
                  if(p.prices.level1IdentifierAsProductVariation){
                    if(o.level1 === pv.id) noPrintOption = o
                  }
                  else{
                    noPrintOption = o
                  }
                }
              })
            }
            if(noPrintOption && noPrintOption.unitPrices[matchedProductPriceRange]){
              unitSalesPrice = noPrintOption.unitPrices[matchedProductPriceRange].price
              unitPurchasePrice = noPrintOption.unitPrices[matchedProductPriceRange].price
              isUnitSalesPriceFromPrices = true
            }
          }
          


          productsData[pv.productId].productVariations[pv.id] = {
            id: pv.id,
            colorCode:pv.colorCode,
            archived:pv.archived ? pv.archived : false,
            warehoused:pv.warehoused ? pv.warehoused : false,
            campaigned:pv.campaigned ? pv.campaigned : false,
            avecorStock:pv.avecorStock ? pv.avecorStock : 0, 
            printShopStock:pv.printShopStock ? pv.printShopStock : 0,
            customersWarehoused: pv.customersWarehoused ? pv.customersWarehoused : {},
            commentsForSales:pv.commentsForSales !== undefined ? pv.commentsForSales : '', 
            name:text, 
            //avecorSku:(t.products[pv.productId].avecorSku ? t.products[pv.productId].avecorSku : '') + (t.products[pv.productId].avecorSku && pv.colorCode ? '-'+pv.colorCode : ''), 
            shelfLocation:pv.shelfLocation !== undefined ? pv.shelfLocation : '',
            unitPurchasePrice,
            unitSalesPrice,
            isUnitSalesPriceFromPrices,
            subtractAlsoPrintShopStock:pv.subtractAlsoPrintShopStock ? pv.subtractAlsoPrintShopStock : false,
            avecorStockNotifyLevel:pv.avecorStockNotifyLevel ? pv.avecorStockNotifyLevel : '',
            printShopStockNotifyLevel:pv.printShopStockNotifyLevel ? pv.printShopStockNotifyLevel : '',
            sendAvecorStockNotifyEmail:pv.sendAvecorStockNotifyEmail ? pv.sendAvecorStockNotifyEmail : '',
          }
          var avecorSku = t.createVariationAvecorSku(pv.id)
          productsData[pv.productId].productVariations[pv.id].avecorSku = avecorSku
          productsData[pv.productId].productVariations[pv.id].batches = {}
          if(pv.batches !== undefined){
            var clonedBatches = JSON.parse(JSON.stringify(pv.batches))
            productsData[pv.productId].productVariations[pv.id].batches = clonedBatches
            /* Object.keys(pv.batches).forEach(batchId => {
              productsData[pv.productId].productVariations[pv.id].batches[batchId] = Object.assign({}, pv.batches[batchId]);
              //console.log(productsData[pv.productId].productVariations[pv.id].batches[batchId])
            }) */
            
          }
          productsData[pv.productId].numberOfExceededArrivalDates === undefined ? productsData[pv.productId].numberOfExceededArrivalDates = 0 : ''
          productsData[pv.productId].numberOfWithin3DaysArrivalDates === undefined ? productsData[pv.productId].numberOfWithin3DaysArrivalDates = 0 : ''
          productsData[pv.productId].numberOfWithin5DaysArrivalDates === undefined ? productsData[pv.productId].numberOfWithin5DaysArrivalDates = 0 : ''
          Object.keys(productsData[pv.productId].productVariations[pv.id].batches).forEach(batchId => {
            var batch = productsData[pv.productId].productVariations[pv.id].batches[batchId]
            productsData[pv.productId].productVariations[pv.id].batches[batchId].batchArrivalDateStatus = ""
            //productsData[pv.productId].productVariations[pv.id].batches[batchId].batchArrivalDateStatus = "ok"
            if(batch.status === "batchArrivedToWarehouse"){
              productsData[pv.productId].productVariations[pv.id].batches[batchId].batchArrivalDateStatus = "arrived"
            }
            else if(batch.status === "batchPartiallyShelfed"){
              productsData[pv.productId].productVariations[pv.id].batches[batchId].batchArrivalDateStatus = "partiallyShelfed"
            }
            else if(batch.status === "batchShelfed"){
              productsData[pv.productId].productVariations[pv.id].batches[batchId].batchArrivalDateStatus = "shelfed"
            }
            else {
              //console.log("HERE")
              //productsData[pv.productId].productVariations[pv.id].batches[batchId].batchArrivalDateStatus = ""
              if(batch.estimatedArrivalDate !== undefined){
                if (new Date(batch.estimatedArrivalDate) - new Date() < 0) {
                  productsData[pv.productId].productVariations[pv.id].batches[batchId].batchArrivalDateStatus = "exceeded"
                  productsData[pv.productId].numberOfExceededArrivalDates += 1
                  //console.log(productsData[pv.productId].numberOfExceededArrivalDates)
                  t.numberOfExceededArrivalDates += 1
                }
                else if ((new Date(batch.estimatedArrivalDate) - new Date() - 259200000) < 0) {
                  productsData[pv.productId].productVariations[pv.id].batches[batchId].batchArrivalDateStatus = "within3days"
                  productsData[pv.productId].numberOfWithin3DaysArrivalDates += 1
                  t.numberOfWithin3DaysArrivalDates += 1
                }
                /* if ((new Date(batch.estimatedArrivalDate) - new Date() - 432000000) < 0) {
                  productsData[pv.productId].productVariations[pv.id].batches[batchId].batchArrivalDateStatus = "within5days"
                  productsData[pv.productId].numberOfWithin5DaysArrivalDates += 1
                  t.numberOfWithin5DaysArrivalDates += 1
                } */
              }
            }
            
          })
          //if(t.internalProductData[pv.id] === undefined) console.log(t.internalProductData[pv.id]) //t.addInternalProductData(pv.id)
          productsData[pv.productId].productVariationSkus === undefined ? productsData[pv.productId].productVariationSkus = "" : ""
          pv.avecorSku !== undefined ? productsData[pv.productId].productVariationSkus += pv.avecorSku : ""
          !productsData[pv.productId].wholesaleSku ? productsData[pv.productId].wholesaleSku = t.products[pv.productId].wholesaleSku : ""
          productsData[pv.productId].productVariationWholesaleSkus === undefined ? productsData[pv.productId].productVariationWholesaleSkus = '' : ''
          if(productsData[pv.productId].productVariationWholesaleSkus === '') productsData[pv.productId].productVariationWholesaleSkus += pv.wholesaleSku ? pv.wholesaleSku : ''
          else pv.wholesaleSku && !productsData[pv.productId].productVariationWholesaleSkus.includes(pv.wholesaleSku) ? productsData[pv.productId].productVariationWholesaleSkus += ', '+ pv.wholesaleSku : ''


          return 
        
        })
        
        //console.log(productsData)
        this.productsData = productsData
      },


      //console.log(pv.batches)
          /* STOCK CALCULATION BASED ON BATCHES */
          /* Object.keys(pv.batches).forEach(batchId => {
            if (batchId === "unallocatedAvecor" || batchId === "unallocatedPrintShop") return
            var batch = pv.batches[batchId]  
            if(batch.stockLocation === "avecor"){
              if(batch.shipped !== undefined && batch.shipped.total !== undefined){
                var stockLeft = pv.batches[batchId].quantity - Number(pv.batches[batchId].shipped.total)
                var unitPrice = batch.unitPrice !== '' ? batch.unitPrice : 0
                this.totalStockInAvecorWarehouse += stockLeft
                this.totalStockValueInAvecorWarehouse += stockLeft * unitPrice
              }
              else {
                var stockLeft = pv.batches[batchId].quantity
                var unitPrice = batch.unitPrice !== '' ? batch.unitPrice : 0
                this.totalStockInAvecorWarehouse += stockLeft
                this.totalStockValueInAvecorWarehouse += stockLeft * unitPrice
              }
            }
            else if (batch.stockLocation === "printShop"){
              if(batch.shipped !== undefined && batch.shipped.total !== undefined){
                var stockLeft = pv.batches[batchId].quantity - Number(pv.batches[batchId].shipped.total)
                var unitPrice = batch.unitPrice !== '' ? batch.unitPrice : 0
                this.totalStockInPrintShopWarehouse += stockLeft
                this.totalStockValueInPrintShopWarehouse += stockLeft * unitPrice
              }
              else {
                var stockLeft = pv.batches[batchId].quantity
                var unitPrice = batch.unitPrice !== '' ? batch.unitPrice : 0
                this.totalStockInPrintShopWarehouse += stockLeft
                this.totalStockValueInPrintShopWarehouse += stockLeft * unitPrice
              }
            }
          }) */
          
          /* if(!isNaN(Number(p.productVariations[pvId].avecorStock))){
            this.totalStockInWarehouse += Number(p.productVariations[pvId].avecorStock)
            this.totalStockInAvecorWarehouse += Number(p.productVariations[pvId].avecorStock)
          }
          if(!isNaN(Number(p.productVariations[pvId].printShopStock))){
            this.totalStockInWarehouse += Number(p.productVariations[pvId].printShopStock)
            this.totalStockInPrintShopWarehouse += Number(p.productVariations[pvId].printShopStock)
          } */
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/blocks/StockTable.vue